// @ts-nocheck
// Generated by server tools/export-client-field-rules.cjs. Do not edit by hand.
// Functions operate only on preview snapshots, never on the live battle.
const import_adaptive_cycle = {
 adaptiveEnvironment(pokemon, kind, id) {
  if (!pokemon?.adaptation?.active) return false;
  let key = id ?? (kind === 'fields' ? pokemon.adaptiveField : pokemon.effectiveWeather());
  if (kind === 'fields' && /^flowergarden[1-5]$/.test(key)) key = 'flowergarden';
  return pokemon.adaptation[kind]?.[key]?.stage === 3;
 },
 adaptiveFieldMultiplier(battle, source, target, multiplier) {
  if (multiplier < 1 && import_adaptive_cycle.adaptiveEnvironment(source, 'fields')) return 1;
  if (multiplier > 1 && import_adaptive_cycle.adaptiveEnvironment(target, 'fields')) return 1;
  return multiplier;
 }
};
const import_ground_bone_moves = {isGroundBoneMove: function isGroundBoneMove(move) {
  return move.type === "Ground" && ["boneclub", "bonerush", "bonemerang"].includes(move.id);
}};
const BattleFieldRules = [
{id: "flowergarden1",
name: "Flower Garden 1",
notes: ["Flower Garden stage 1/5. Growth and Rototiller raise Attack and Special Attack by 2; Flower Gift and Swarm activate.","Growth effects advance the garden. Cut and X-Scissor cannot lower it further. This stage cannot ignite. Auras are rejected."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    if (move.type === "Grass")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, [1, 1, 1.1, 1.3, 1.5, 2][1]);
    if (move.type === "Bug")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, [1, 1, 1, 1.5, 2, 2][1]);
    if (move.type === "Fire" && 1 >= 3)
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    if (1 >= 2 && move.id === "cut")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, target.hasType("Grass") ? 2 : 1.5);
    if (1 >= 3 && ["fleurcannon", "flowertrick", "petalblizzard", "petaldance", "springtidestorm"].includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1 === 3 ? 1.2 : 1.5);
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    if (1 === 5 && (["petaldance", "petalblizzard"].includes(move.id) || move.flags.powder && move.id !== "ragepowder" && ["normal", "adjacentFoe", "randomNormal", "allAdjacent"].includes(move.target))) {
        move.target = "allAdjacentFoes";
    }
},
onModifyPriority(priority, pokemon, target, move) {
    if (1 >= 4 && move.id === "grassyglide")
        return priority + 1;
},
uncertain: false},
{id: "flowergarden2",
name: "Flower Garden 2",
notes: ["Flower Garden stage 2/5. Grass attacks gain 1.1x power. Cut gains 1.5x power, or 2x against Grass. Harvest and Leaf Guard activate; Ingrain healing doubles.","Growth effects advance the garden. Cut and X-Scissor lower it one stage. This stage cannot ignite. Auras are rejected."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    if (move.type === "Grass")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, [1, 1, 1.1, 1.3, 1.5, 2][2]);
    if (move.type === "Bug")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, [1, 1, 1, 1.5, 2, 2][2]);
    if (move.type === "Fire" && 2 >= 3)
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    if (2 >= 2 && move.id === "cut")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, target.hasType("Grass") ? 2 : 1.5);
    if (2 >= 3 && ["fleurcannon", "flowertrick", "petalblizzard", "petaldance", "springtidestorm"].includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2 === 3 ? 1.2 : 1.5);
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    if (2 === 5 && (["petaldance", "petalblizzard"].includes(move.id) || move.flags.powder && move.id !== "ragepowder" && ["normal", "adjacentFoe", "randomNormal", "allAdjacent"].includes(move.target))) {
        move.target = "allAdjacentFoes";
    }
},
onModifyPriority(priority, pokemon, target, move) {
    if (2 >= 4 && move.id === "grassyglide")
        return priority + 1;
},
uncertain: false},
{id: "flowergarden3",
name: "Flower Garden 3",
notes: ["Flower Garden stage 3/5. Grass attacks gain 1.3x, Bug and Fire attacks 1.5x, and flower moves 1.2x power. Flower Veil protects allies; the garden can ignite.","Growth effects advance the garden. Cut and X-Scissor lower it one stage. Fire ignition moves can start Burning Field. Auras are rejected."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    if (move.type === "Grass")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, [1, 1, 1.1, 1.3, 1.5, 2][3]);
    if (move.type === "Bug")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, [1, 1, 1, 1.5, 2, 2][3]);
    if (move.type === "Fire" && 3 >= 3)
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    if (3 >= 2 && move.id === "cut")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, target.hasType("Grass") ? 2 : 1.5);
    if (3 >= 3 && ["fleurcannon", "flowertrick", "petalblizzard", "petaldance", "springtidestorm"].includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 3 === 3 ? 1.2 : 1.5);
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    if (3 === 5 && (["petaldance", "petalblizzard"].includes(move.id) || move.flags.powder && move.id !== "ragepowder" && ["normal", "adjacentFoe", "randomNormal", "allAdjacent"].includes(move.target))) {
        move.target = "allAdjacentFoes";
    }
},
onModifyPriority(priority, pokemon, target, move) {
    if (3 >= 4 && move.id === "grassyglide")
        return priority + 1;
},
uncertain: false},
{id: "flowergarden4",
name: "Flower Garden 4",
notes: ["Flower Garden stage 4/5. Grass attacks gain 1.5x, Bug attacks 2x, Fire attacks 1.5x, and flower moves 1.5x power. Grass weaknesses are annulled; Ingrain healing is quadrupled.","Growth effects advance the garden. Cut and X-Scissor lower it one stage. Fire ignition moves can start Burning Field. Auras are rejected."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    if (move.type === "Grass")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, [1, 1, 1.1, 1.3, 1.5, 2][4]);
    if (move.type === "Bug")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, [1, 1, 1, 1.5, 2, 2][4]);
    if (move.type === "Fire" && 4 >= 3)
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    if (4 >= 2 && move.id === "cut")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, target.hasType("Grass") ? 2 : 1.5);
    if (4 >= 3 && ["fleurcannon", "flowertrick", "petalblizzard", "petaldance", "springtidestorm"].includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 4 === 3 ? 1.2 : 1.5);
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    if (4 === 5 && (["petaldance", "petalblizzard"].includes(move.id) || move.flags.powder && move.id !== "ragepowder" && ["normal", "adjacentFoe", "randomNormal", "allAdjacent"].includes(move.target))) {
        move.target = "allAdjacentFoes";
    }
},
onModifyPriority(priority, pokemon, target, move) {
    if (4 >= 4 && move.id === "grassyglide")
        return priority + 1;
},
uncertain: false},
{id: "flowergarden5",
name: "Flower Garden 5",
notes: ["Flower Garden stage 5/5. Grass and Bug attacks gain 2x power; Fire attacks 1.5x and flower moves 1.5x. Grass weaknesses are annulled; eligible petal and powder moves hit both foes.","Growth effects advance the garden. Cut and X-Scissor lower it one stage. Fire ignition moves can start Burning Field. Auras are rejected."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    if (move.type === "Grass")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, [1, 1, 1.1, 1.3, 1.5, 2][5]);
    if (move.type === "Bug")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, [1, 1, 1, 1.5, 2, 2][5]);
    if (move.type === "Fire" && 5 >= 3)
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    if (5 >= 2 && move.id === "cut")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, target.hasType("Grass") ? 2 : 1.5);
    if (5 >= 3 && ["fleurcannon", "flowertrick", "petalblizzard", "petaldance", "springtidestorm"].includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 5 === 3 ? 1.2 : 1.5);
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    if (5 === 5 && (["petaldance", "petalblizzard"].includes(move.id) || move.flags.powder && move.id !== "ragepowder" && ["normal", "adjacentFoe", "randomNormal", "allAdjacent"].includes(move.target))) {
        move.target = "allAdjacentFoes";
    }
},
onModifyPriority(priority, pokemon, target, move) {
    if (5 >= 4 && move.id === "grassyglide")
        return priority + 1;
},
uncertain: false},
{id: "ashenbeachterrain",
name: "Ashen Beach Terrain",
notes: ["Fighting Pokémon and Inner Focus holders cannot become confused. Sand Tomb lowers accuracy each turn. Accuracy and move bonuses are listed below."],
onBasePower(basePower, source, target, move) {
    const uberboost = ["sandtomb", "mudbomb", "mudshot", "mudbarrage"];
    const megaboost = ["hiddenpower", "landswrath", "muddywater", "strength", "surf", "thousandwaves", "clangoroussoulblaze"];
    const miniboost = ["aurasphere", "focusblast", "storedpower", "zenheadbutt"];
    const boost = ["psychic"];
    let modifier = 1;
    if (uberboost.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    if (megaboost.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (miniboost.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    if (boost.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.2);
    }
    return this.chainModify(modifier);
},
onAccuracy(accuracy, target, source, move) {
    const noguard = ["owntempo", "purepower", "sandveil", "steadfast"];
    if (!target.hasAbilityOrPassive("unnerve") && source.hasAbilityOrPassive(noguard)) {
        return true;
    }
    return accuracy;
},
uncertain: false},
{id: "bewitchedwoodsterrain",
name: "Bewitched Woods Terrain",
notes: ["Sleeping Pokémon lose 1/16 HP. Grounded Grass Pokémon heal 1/16 HP. Eternal Flower/Ange grant 1.5× defenses, status immunity and 1/16 healing. Fairy is super effective against Steel and neutral against Dark/Poison; Poison is resisted by Fairy and neutral against Grass. Accepts Auras but blocks their conversion."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const boostMoves = ["hex", "mysticalfire", "spiritbreak"];
    const weakerboostMoves = ["aurorabeam", "bubblebeam", "chargebeam", "flashcannon", "hyperbeam", "icebeam", "magicalleaf", "mirrorbeam", "psybeam", "signalbeam"];
    const weakBoost = ["darkpulse", "moonblast", "nightdaze", "vorpalblade"];
    const blessedMoves = ["judgement", "originpulse", "purify", "sacredfire", "dazzlinggleam", "flash"];
    if (move.type === "Fairy") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
        this.add("-message", "The fairy aura amplified the attack's power!");
    }
    if (move.type === "Grass") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
        this.add("-message", "Flourish!");
    }
    if (move.type === "Dark") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
        this.add("-message", "The dark aura amplified the attack's power!");
    }
    if (boostMoves.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
        this.add("-message", "Mystical aura amplified the attack!");
    }
    if (weakerboostMoves.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.4);
        this.add("-message", "Magic aura amplified the attack!");
    }
    if (weakBoost.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.2);
        this.add("-message", "The forest is cursed with nightfall!");
    }
    if (blessedMoves.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
        this.add("-message", "The evil spirits have been exorcised!");
    }
    return this.chainModify(modifier);
},
uncertain: false},
{id: "bigtopterrain",
name: "Big Top Terrain",
notes: ["Physical Fighting attacks and designated striking moves receive a high-striker damage roll: 0.5×, 1×, 1.5×, 2× or 3×. The roll uses the existing Striker Bonus rules. Sound, dance and acrobatic move changes are listed below."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const boost = ["winddance", "acrobatics", "fierydance", "firelash", "firstimpression", "fly", "petaldance", "powerwhip", "revelationdance", "vinewhip"];
    if (move.id === "payday" || move.id === "makeitrain") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    if (move.flags.sound || move.id === "drumbeating") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (boost.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.id === "skittersmack" || move.id === "bodypress" || move.id === "tripleaxel") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.2);
    }
    return this.chainModify(modifier);
},
onTryMove(source, target, move) {
    const beast = ["firelash", "vinewhip", "powerwhip"];
    const dance = ["fierydance", "petaldance", "revelationdance"];
    const air = ["acrobatics", "fly"];
    const multi = ["tripleaxel", "triplekick"];
    const flat = ["skittersmack", "bodypress"];
    const pay = ["payday", "makeitrain"];
    if (beast.includes(move.id)) {
        this.add("-message", "Back, foul beast!");
    }
    if (dance.includes(move.id)) {
        this.add("-message", "What grace!");
    }
    if (air.includes(move.id)) {
        this.add("-message", "An extravagant aerial finish!");
    }
    if (move.id === "firstimpression") {
        this.add("-message", "And what an entrance it is!");
    }
    if (multi.includes(move.id)) {
        this.add("-message", "And A-One, and A-Two!");
    }
    if (flat.includes(move.id)) {
        this.add("-message", "A flattening performance!");
    }
    if (pay.includes(move.id)) {
        this.add("-message", "And a little extra for you, darling!");
    }
    if (move.flags.sound || move.id === "drumbeating") {
        this.add("-message", "Loud and Clear!");
    }
},
uncertain: false},
{id: "burningterrain",
name: "Burning Terrain",
notes: ["Prevents freezing. Grounded non-Fire Pokémon without a protective ability or Aqua Ring take Fire-effectiveness-scaled residual damage based on 1/8 HP; vulnerable abilities and Tar Shot double it. Hail is removed. Rain/sand can extinguish the field. Blazing Mane grants +1 Speed on entry."],
onBasePower(basePower, source, target, move) {
    const terrainEndMoves = ["defog", "gust", "winddance", "airstreamassault", "hurricane", "muddywater", "sandtomb", "razorwind", "sludgewave", "sparklingaria", "surf", "waterpledge", "watersport", "waterspout", "hydrovortex", "tailwind", "twister", "whirlwind", "oceanicoperetta", "continentalcrush", "supersonicskystrike", "gmaxwindrage"];
    const rockfireMoves = ["rockslide", "smackdown", "thousandarrows"];
    const smogfireMoves = ["smog", "clearsmog"];
    let modifier = 1;
    if (move.type === "Fire" && source.isGrounded()) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.id === "infernalparade") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.type === "Grass" && target.isGrounded()) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    }
    if (move.type === "Ice") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    }
    if (rockfireMoves.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    if (smogfireMoves.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (terrainEndMoves.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    const fireMoves = ["rockslide", "smackdown", "thousandarrows", "clearsmog", "smog"];
    if (fireMoves.includes(move.id)) {
        move.types = [move.type, "Fire"];
    }
},
uncertain: false},
{id: "caveterrain",
name: "Cave Terrain",
notes: ["Ground attacks can affect airborne Pokémon. Repeated disruptive attacks can collapse or transform the cave; move-dependent power/type changes are listed below."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const icy = ["blizzard", "subzeroslammer"];
    const cavern = ["powergem", "diamondstorm"];
    const burning = ["magmadrift", "feverpitch", "heatwave", "lavaplume", "overheat", "incinerate", "inferno", "flameburst", "firepledge", "sacredfire"];
    const explosive = ["blastburn", "eruption", "infernooverdrive", "fusionfame", "mindblown", "searingshot", "burnup"];
    const dragonMove = ["dragonpulse", "dragonenergy"];
    const uberDragon = ["devastatingdrake", "dracometeor", "coreenforcer"];
    if (move.id === "rocktomb") {
        this.add("message", "...Piled on!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.type === "Rock") {
        this.add("-message", "The cavern strengthened the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.flags.sound) {
        this.add("-message", "Echo-Echo-Echo");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.type === "Flying" && !move.flags.contact) {
        this.add("-message", "The cave choked out the air!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    }
    if (cavern.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    if ((move.id !== "magmadrift" || !this.field.moveTransitionBlocked(source, move)) && (explosive.includes(move.id) || burning.includes(move.id) && this.field.terrainState.terrainChanges?.get("volcanicterrain") === 1)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    if (move.isMax && (move.type === "Dragon" || move.type === "Fire")) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    if (dragonMove.includes(move.id) || uberDragon.includes(move.id) && this.field.terrainState.terrainChanges?.get("dragonsdenterrain") === 1) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    if (icy.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    return this.chainModify(modifier);
},
uncertain: true},
{id: "chessboardterrain",
name: "Chess Board Terrain",
notes: ["Roles: King adds +1 move priority. Rook and Queen gain +1 Defense and Special Defense on entry. Bishop gains +1 Attack and Special Attack on entry. A full-HP Pawn survives one otherwise lethal direct attack with 1 HP, then becomes a used Pawn.","Queen attacks gain 1.5× power. Knight attacks against a Queen gain 3×; Knight attacks targeting all adjacent foes gain another 1.25×.","Ancient Power, Barrage, Continental Crush, Psychic, Rock Throw, Secret Power, Shattered Psyche and Strength gain Rock typing and 1.5× power. They gain another 2× against confused targets or targets with Unaware, Simple, Klutz, Oblivious or Defeatist; Adaptability, Synchronize, Anticipation and Telepathy instead halve them. Barrage also gains its own 2× bonus.","Fake Out, Feint, Feint Attack, First Impression, Shadow Sneak, Smart Strike and Sucker Punch gain 1.5×. Stomping Tantrum and Tectonic Rage gain 1.3×. Stomping Tantrum, Outrage and Thrash gain a critical-hit stage. Attacks against Reckless or Gorilla Tactics gain a critical-hit stage.","Accepts Auras, but blocks replacement by other full fields and Aura conversion."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const chessMoves = ["queensgambit", "ancientpower", "barrage", "continentalcrush", "psychic", "rockthrow", "secretpower", "shatteredpsyche", "strength"];
    ;
    const boost = ["fakeout", "feint", "feintattack", "firstimpression", "shadowsneak", "smartstrike", "suckerpunch"];
    const dumbAbilities = ["unaware", "simple", "klutz", "oblivious", "defeatist"];
    const smartAbilities = ["adaptability", "synchronize", "anticipation", "telepathy"];
    const breakMoves = ["stompingtantrum", "tectonicrage"];
    if (move.id === "barrage") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    if (chessMoves.includes(move.id)) {
        if (target.hasAbilityOrPassive(dumbAbilities) || target.volatiles["confusion"] || move.id === "queensgambit" && target.hasAbilityOrPassive("gorillatactics")) {
            this.add("-message", "The complicated move made the pokemon cross-eyed!");
            modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
        }
        if (target.hasAbilityOrPassive(smartAbilities) || move.id === "queensgambit" && target.hasAbilityOrPassive("opportunist")) {
            this.add("-message", "The complicated move was easily analyzed by the pokemon!");
            modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
        }
        this.add("-message", "The chess piece slammed forward!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (boost.includes(move.id)) {
        this.add("-message", "En Passant!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (source.Role === "Queen") {
        this.add("-message", "The Queen is dominating the board!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (source.Role === "Knight") {
        if (target.Role === "Queen") {
            this.add("-message", "An unblockable attack on the Queen!");
            modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 3);
        }
        if (move.target === "allAdjacentFoes") {
            this.add("-message", "The knight forked the opponents!");
            modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.25);
        }
    }
    if (breakMoves.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    const chessMoves = ["queensgambit", "ancientpower", "barrage", "continentalcrush", "psychic", "rockthrow", "secretpower", "shatteredpsyche", "strength"];
    ;
    const crazyMoves = ["stompingtantrum", "outrage", "thrash"];
    if (chessMoves.includes(move.id)) {
        move.types = [move.type, "Rock"];
    }
    if (crazyMoves.includes(move.id)) {
        move.critRatio = move.critRatio !== void 0 ? move.critRatio + 1 : 1;
    }
},
onModifyPriority(priority, source, target, move) {
    if (source.Role === "King") {
        return priority + 1;
    }
},
uncertain: false},
{id: "coldeclipseterrain",
name: "Cold Eclipse Terrain",
notes: ["Ice and Ghost types each grant 1.2x Defense and Special Defense, stacking to 1.44x for Ice/Ghost; Fire types receive 0.8x defenses. Ice Scales doubles Defense; Prism Armor gives 4/3x Defense and Special Defense, on both Cold and Infernal Eclipse. Dragon typing resists Ice, including added Ice typing, and Dragons remain protected from hail and frostbite.","Ice attacks gain 1.2x power; Dark attacks gain 1.5x. Rock, Steel, Ground and Water attacks retain their Ice subtyping (bone moves and Armorize Steel exceptions apply). Dragon attacks gain 2x power. There is no blanket wind power boost.","New Rooms and Gravity fail. Existing Rooms and Gravity pause until Cold Eclipse ends. Auras keep their ordinary timers. Hail lasts 8 turns and deals 1/8 damage to susceptible targets; rain and sand are not converted and sun does not clear the field.","Heating attacks thaw the field into Rift Eclipse. Cold Eclipse plus Ashen Aura and a successful Eruption instead changes directly to Infernal Eclipse, consumes Ashen Aura and retains the field timer. Purify leaves permanent Icy Field with normal Cave transitions, removable by Ice Spinner or Steel Roller. Active Bad Seeds blocks changes and destruction, but not natural expiry. Geomancy and Light of Ruin create permanent Starlight Arena.","Elemental Seed grants +2 Speed and Torment without changing type. Nature Power calls Ice Beam.","Bad Seeds retains direct full-field entry on no field or Icy Field. While Frozen Aura is active, its unsuppressed holder can develop it with successful Blizzard, Glaciate or Sheer Cold; the Aura is consumed and its remaining turns carry over, except the specific Infernal Eclipse plus Frozen Aura plus Glaciate or Sheer Cold route keeps the field timer."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const types = move.types || [move.type];
    if (types.includes("Ice"))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.2);
    if (types.includes("Dragon"))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    if (types.includes("Dark"))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    if ([
        "fierywrath",
        "freezingglare",
        "lashout",
        "outrage",
        "ragingfury",
        "rage",
        "roaroftime",
        "stompingtantrum",
        "thrash",
        "bittermalice"
    ].includes(move.id))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    if (["hyperspacehole", "hyperspacefury"].includes(move.id))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.2);
    return this.chainModify(modifier);
},
onModifyMove(move, pokemon) {
    if (["Rock", "Steel", "Ground", "Water"].includes(move.type) && !(0, import_ground_bone_moves.isGroundBoneMove)(move) && !(pokemon.hasAbilityOrPassive("armorize") && move.type === "Steel") && !move.types?.includes("Ice")) {
        move.types = [...move.types || [move.type], "Ice"];
    }
    if (["freezeshock", "iceburn"].includes(move.id))
        delete move.flags.charge;
    if (move.id === "rage") {
        move.basePower = 60;
        move.type = "Dark";
        move.category = "Physical";
        move.self = { boosts: { atk: 1 } };
    }
    if (move.id === "snarl")
        move.secondaries = [{ chance: 100, boosts: { spa: -2 } }];
    if (move.id === "chillingwater")
        move.secondaries = [{ chance: 100, boosts: { atk: -2 } }];
    if (move.id === "partingshot")
        move.boosts = { ...move.boosts, spe: -1 };
},
onAccuracy(accuracy, target, source, move) {
    if (["blizzard", "icywind", "coldsnap", "darkvoid"].includes(move.id))
        return true;
},
onTryMove(source, target, move) {
    if (["trickroom", "wonderroom", "gravity", "magicroom"].includes(move.id)) {
        this.add("-message", "The frozen reality cannot be changed!");
        return false;
    }
},
uncertain: false},
{id: "rifteclipseterrain",
name: "Rift Eclipse Terrain",
notes: ["Dark attacks gain 1.5x power; Ghost attacks gain 1.2x; Fairy attacks receive 0.5x. Ghost types gain 1.2x defenses. Sleeping Pokemon lose 1/16 HP each turn, subject to indirect-damage immunity.","New Rooms and Gravity last 8 turns. Rattled grants +1 Speed, Berserk +1 Special Attack, and Justified +1 Attack on switch-in. Magical Seed grants +1 Defense and Trick Room.","Rift Opening and Rift Herald create full Rift Eclipse on an empty field; over another field they create Rift Aura without replacing the base. New effects last 5 turns (8 with Amplifield Rock). Any user can develop an existing Rift Aura with successful Rift Opening, consuming the Aura and keeping its remaining turns. The ability can prepare the Aura for one-use development; repeated ability entry does not develop or refresh it. Full Rift Eclipse is not refreshed. Establishing Trick Room and Magic Room on the same field also opens it. Other Eclipse transformations share the remaining field timer.","Two heating points create Infernal Eclipse; two freezing points create Cold Eclipse. Opposing heat and cold cancel progress. Purify or Seed Flare cancels the dimension. Weather and Auras function normally.","Spacial Rend, Roar of Time, Hyperspace Hole/Fury, Shadow Force, Phantom Force, Dynamax Cannon and Eternabeam gain 1.5x. Dark Pulse/Night Daze ignore accuracy checks. Quash gains +1 priority. Nature Power calls Dark Pulse."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const types = move.types || [move.type];
    if (types.includes("Dark"))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    if (types.includes("Ghost"))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.2);
    if (types.includes("Fairy"))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    if ([
        "spacialrend",
        "roaroftime",
        "hyperspacehole",
        "hyperspacefury",
        "shadowforce",
        "phantomforce",
        "dynamaxcannon",
        "eternabeam"
    ].includes(move.id))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    return this.chainModify(modifier);
},
onModifyMove(move) {
    if (move.id === "rage") {
        move.basePower = 60;
        move.type = "Dark";
        move.category = "Physical";
        move.self = { boosts: { atk: 1 } };
    }
},
onAccuracy(accuracy, target, source, move) {
    if (["darkpulse", "nightdaze"].includes(move.id))
        return true;
},
onModifyPriority(priority, pokemon, target, move) {
    if (move.id === "quash")
        return priority + 1;
},
uncertain: false},
{id: "infernaleclipseterrain",
name: "Infernal Eclipse Terrain",
notes: ["Fire and Ghost types each gain 1.2x Defense and Special Defense, stacking to 1.44x for Fire/Ghost. Ice types receive 0.8x defenses. Ice Scales doubles Defense and Prism Armor gives 4/3x both defenses independently of typing.","Fire and Dark attacks gain 1.5x power; Dragon attacks gain 2x. Water, Ice and Fairy attacks receive 0.5x power; Spirit Break is exempt from the Fairy penalty. Fire is super effective against Ghost typing.","Rock, Steel, Ground and Ice attacks gain Fire subtyping; Ground bone moves and Armorize Steel exceptions apply. Aura Sphere, Frustration and Spirit Break gain Dark subtyping. Type modifiers and named move modifiers stack.","Blast Burn, Infernal Parade, Inferno, Inferno Overdrive, Earth Power, Precipice Blades and Raging Fury gain an additional 1.5x power. Punishment, Smog and Dream Eater gain 2x. Inferno, Will-O-Wisp and Dark Void ignore accuracy checks. Infernal Parade always attempts burn; Hex doubles regardless of status, once.","Grounded non-Fire Pokemon take Fire-scaled damage based on 1/16 HP, capped at 1/8; volcanic protections and Magic Guard apply. Existing Rain, heavy rain and Hail are cleared, and new attempts to start them fail. Infernal Eclipse does not summon Sun.","Blaze and Flare Boost activate without their usual HP/status requirement. Steam Engine grants +1 Speed each turn. Elemental Seed gives +1 Attack/Special Attack and four-turn Fire Spin. Nature Power calls Infernal Parade.","Nasty Plot gives +3 Special Attack. Torment deals an extra 1/8 HP each turn; Nightmare works on awake targets for 1/4 HP. Bad Dreams deals 1/4 HP to sleeping or Comatose foes and traps adjacent ones; indirect-damage immunity applies. Perish Body traps only an opposing contact attacker and makes it faint at the end of the following turn if it remains active.","Flash Fire activates immediately; a field-only charge ends on leaving. Desolate Land, Flame Body and Magma Armor grant +1 Defense/Special Defense on entry. Magma Armor nullifies Fire attacks, Ice Face melts, and Pastel Veil is inactive. Burn Up restores its saved typing at turn end if no other type change intervenes and this field remains. Stealth Rock uses Fire effectiveness.","Two cooling points return to Rift Eclipse; heat cancels cooling progress. Infernal Eclipse plus Frozen Aura and a successful Glaciate or Sheer Cold instead changes directly to Cold Eclipse, consumes Frozen Aura and retains the field timer. Purify, Judgment and Origin Pulse leave permanent Volcanic Field with normal Cave transitions, removable by Ice Spinner or Steel Roller. Geomancy and Light of Ruin create permanent Starlight Arena. All transitions respect field locks.","Ashen Seeds creates full Infernal Eclipse on no field or Volcanic Field; otherwise it creates Ashen Aura. Its holder can develop that Aura with successful Infernal Parade or Eruption, using the remaining Aura turns except the specific Cold Eclipse plus Ashen Aura plus Eruption route keeps the field timer. Full field only: Fire-weakness damage is halved, eligible non-Fire contact attackers acquire Ashen Seeds, non-Fire holders lose Attack and Special Attack each turn, and active holders block field changes/destruction but not expiry."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const types = move.types || [move.type];
    if (types.includes("Fire"))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    if (types.includes("Dragon"))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    if (types.includes("Dark"))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    if (types.includes("Water"))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    if (types.includes("Ice"))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    if (types.includes("Fairy") && move.id !== "spiritbreak")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    if (["blastburn", "infernalparade", "inferno", "infernooverdrive", "earthpower", "precipiceblades", "ragingfury"].includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (["punishment", "smog", "dreameater"].includes(move.id))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    return this.chainModify(modifier);
},
onModifyMove(move, pokemon) {
    if (["Rock", "Steel", "Ground", "Ice"].includes(move.type) && !(0, import_ground_bone_moves.isGroundBoneMove)(move) && !(pokemon.hasAbilityOrPassive("armorize") && move.type === "Steel") && !move.types?.includes("Fire")) {
        move.types = [...move.types || [move.type], "Fire"];
    }
    if (["aurasphere", "frustration", "spiritbreak"].includes(move.id) && !move.types?.includes("Dark")) {
        move.types = [...move.types || [move.type], "Dark"];
    }
    if (move.id === "infernalparade")
        move.secondaries = [{ chance: 100, status: "brn" }];
},
onAccuracy(accuracy, target, source, move) {
    if (["inferno", "willowisp", "darkvoid"].includes(move.id))
        return true;
},
uncertain: false},
{id: "corrosivemistterrain",
name: "Corrosive Mist Terrain",
notes: ["Poisons eligible non-Poison/non-Steel Pokémon at turn end and applies immediate poison damage when newly poisoned, unless its Neutralizing Gas field state prevents this. Gravity turns it into Corrosive Field. Misty Aura is rejected."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const poisonedMoves = ["appleacid", "bubble", "bubblebeam", "sparklingaria"];
    const smogMoves = ["smog", "clearsmog", "acidspray"];
    const terrainEndMoves = ["defog", "gust", "winddance", "airstreamassault", "hurricane", "razorwind", "tailwind", "twister", "whirlwind", "supersonicskystrike", "seedflare", "gmaxwindrage"];
    const igniteMoves = ["infernalrage", "eruption", "explosion", "firepledge", "flameburst", "heatwave", "incinerate", "lavaplume", "mindblown", "searingshot", "selfdestruct", "infernooverdrive"];
    if (move.type === "Fire") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (poisonedMoves.includes(move.id))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    if (smogMoves.includes(move.id))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    if (terrainEndMoves.includes(move.id) || igniteMoves.includes(move.id) || move.isMax && move.type === "Fire")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    if (move.id === "seedflare")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    return this.chainModify(modifier);
},
onModifyMove(move) {
    const poisonedMoves = ["appleacid", "bubblebeam", "bubble", "sparklingaria", "energyball"];
    if (move.type === "Flying" && move.category === "Special") {
        move.types = ["Flying", "Poison"];
    }
    if (poisonedMoves.includes(move.id)) {
        move.types = [move.type, "Poison"];
    }
},
uncertain: false},
{id: "corrosiveterrain",
name: "Corrosive Terrain",
notes: ["Grounded entrants without Poison/Steel typing or Immunity, Magic Guard, Poison Heal, Toxic Boost or Wonder Guard take Poison-effectiveness-scaled damage based on 1/4 HP. Unprotected sleeping/Comatose Pokémon lose 1/16 HP each turn."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const superStrong = ["acid", "acidspray", "grassknot", "snaptrap"];
    const poisonedMoves = ["mudbomb", "mudshot", "mudbarrage", "muddywater", "smackdown", "whirlpool", "thousandarrows", "appleacid"];
    if (superStrong.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    if (poisonedMoves.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.id === "seedflare") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    const powderMoves = ["poisonpowder", "stunspore", "sleeppowder", "toxic"];
    if (powderMoves.includes(move.id)) {
        move.accuracy = 100;
    }
    const poisonedMoves = ["mudbomb", "mudshot", "mudbarrage", "muddywater", "smackdown", "whirlpool", "thousandarrows", "appleacid"];
    if (move.type === "Grass") {
        move.types = [move.type, "Poison"];
    }
    if (poisonedMoves.includes(move.id)) {
        move.types = [move.type, "Poison"];
    }
},
uncertain: false},
{id: "crystalcavernterrain",
name: "Crystal Cavern Terrain",
notes: ["Rock and designated crystal attacks cycle an additional type through Fire, Water, Grass and Psychic. The current crystal cycle affects outcomes. A cavern brightened by Sunny Day returns to Dark Crystal when that sunlight ends."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const crystalBoost = ["judgement", "multiattack", "rockclimb", "strength", "prismaticlaser"];
    const boost = ["ancientpower", "diamondstorm", "powergem", "rocksmash", "rocktomb"];
    const weakboost = ["aurorabeam", "doomdesire", "dazzlinggleam", "flashcannon", "mirrorbeam", "lusterpurge", "mirrorshot", "moongeistbeam", "photongeyser", "signalbeam", "technoblast", "menacingmoonrazemaelstorm"];
    const terrainbreak = ["bulldoze", "earthquake", "fissure", "magnitude", "tectonicrage"];
    const dark = ["darkpulse", "darkvoid", "nightdaze", "lightthatburnsthesky"];
    if (move.type === "Rock") {
        this.add("-message", "The crystals charged the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.type === "Dragon") {
        this.add("-message", "The crystal energy strengthened the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (crystalBoost.includes(move.id)) {
        this.add("-message", "The crystals strengthened the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (boost.includes(move.id)) {
        this.add("-message", "The crystals' light strengthened the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (weakboost.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    if (terrainbreak.includes(move.id) && (this.field.terrainState.terrainChanges?.get("caveterrain") === 1 || move.id === "tectonicrage")) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    if (dark.includes("move.id") && this.field.weather !== "sunnyday") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    const crystalBoost = ["judgement", "multiattack", "rockclimb", "strength", "prismaticlaser"];
    const counter = ["Fire", "Water", "Grass", "Psychic"];
    if (move.category !== "Status" && (move.type === "Rock" || crystalBoost.includes(move.id))) {
        move.types = ["Rock", counter[this.CrystalCavernCounter]];
    }
},
uncertain: true},
{id: "darkcrystalcavernterrain",
name: "Dark Crystal Cavern Terrain",
notes: ["Dark and Ghost Pokémon gain 1.5× Defense and Special Defense. Sunny Day brightens it into Crystal Cavern."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const superboost = ["prismaticlaser"];
    const boost = ["ceaselessedge", "blackholeeclipse", "darkpulse", "nightdaze", "nightslash", "menacingmoonrazemaelstrom", "shadowball", "shadowbone", "shadowclaw", "shadowforce", "shadowpunch", "shadowsneak", "aurorabeam", "dazzlinggleam", "diamondstorm", "doomdesire", "flashcannon", "lusterpurge", "mirrorbeam", "mirrorshot", "moongeistbeam", "photongeyser", "powergem", "signalbeam", "technoblast"];
    const terrainbreak = ["bulldoze", "earthquake", "fissure", "magnitude", "tectonicrage"];
    if (superboost.includes(move.id)) {
        this.add("-message", "The field super charged the attack");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    if (boost.includes(move.id)) {
        this.add("-message", "The field strengthened the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.id === "lightthatburnsthesky") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    }
    if (terrainbreak.includes(move.id) && this.field.terrainState.terrainChanges?.get("caveterrain") === 1) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    return this.chainModify(modifier);
},
uncertain: true},
{id: "desertterrain",
name: "Desert Terrain",
notes: ["Ground Pokémon gain 1.5× Special Defense. Water attacks against other Water/Grass Pokémon heal the target by 1/4 HP instead. Sun damages Water/Grass Pokémon by 1/8 HP unless protected by Chlorophyll or Solar Power."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const sandified = ["burnup", "dig", "needlearm", "heatwave", "pinmissile", "sandtomb", "sandsearstorm", "scald", "scorchingsands", "searingsunrazesmash", "solarbeam", "solarblade", "steameruption", "thousandwaves", "hydrosteam"];
    const steamMoves = ["steameruption", "scald", "hydrosteam"];
    const boneBoost = ["bonemerang", "boneclub", "bonerush", "shadowbone"];
    if (move.type === "Water" && source.isGrounded() && !steamMoves.includes(move.id)) {
        this.add("-message", "The intense desert heat blunted the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    }
    if (move.type === "Electric" && target.isGrounded()) {
        this.add("-message", "The floating sand particles partially grounded the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    }
    if (sandified.includes(move.id)) {
        this.add("-message", "The harsh desert heat augmented the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (boneBoost.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
        this.add("-message", "The lifeless desert strengthened the attack!");
    }
    return this.chainModify(modifier);
},
onTryMove(source, target, move) {
    const evaporated = ["soak", "aquaring", "lifedew"];
    if (evaporated.includes(move.id)) {
        this.debug("Desert suppress");
        this.add("-fail", source, move, "[from] Desert Terrain");
        this.add("-message", "the desert is too dry...");
        this.attrLastMove("[still]");
        return null;
    }
},
uncertain: false},
{id: "dragonsdenterrain",
name: "Dragon's Den Terrain",
notes: ["Rejects Auras and ordinary field replacement. Dragon Pokémon gain 1.3× Defense. Multiscale removes super-effective bonuses against Dragon typing. Cooling moves announce progress toward Cave. Hail and snow fail here. Fickle Beam and Worldbreaker have a 50% all-out chance. Dragon Cheer grants Dragon allies +3 crit stages. Scale Shot keeps Defense. Good as Gold neutralizes Steel weaknesses. Tyrant Domain maintains the Den and lowers opposing defenses on entry."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const uberboost = ["smackdown", "thousandarrows", "continentalcrush", "tectonicrage", "dragonascent", "payday", "lusterpurge", "mistball"];
    const boost = ["magmadrift", "matrixshot", "lavaplume", "magmastorm", "megakick", "makeitrain", "rockclimb", "strength", "diamondstorm", "makeitrain", "powergem", "shelltrap", "earthpower", "stompingtantrum"];
    const terrain_change = ["glaciate", "hydrovortex", "oceanicoperetta", "subzeroslammer", "mistball"];
    const terrain_change1 = ["muddywater", "surf"];
    const change = terrain_change1.includes(move.id) ? 1 : move.id === "sparklingaria" ? 2 : 0;
    const current = this.field.terrainState.terrainChanges?.get("caveterrain") ?? 0;
    if (move.type === "Dragon" || move.type === "Fire") {
        this.add("-message", "The ambient dragon fire boosted the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.type === "Ice" || move.type === "Water") {
        this.add("-message", "The lava's heat softened the attack...");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    }
    if (boost.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (uberboost.includes(move.id)) {
        this.add("-message", "The draconic energy boosted the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    if (terrain_change.includes(move.id) || current + change >= 3) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    const moveMessages = /* @__PURE__ */ new Map([
        ["megakick", "Trial of the Dragon!!!"],
        ["magmastorm", "The lava strengthened the attack!"],
        ["lavaplume", "The lava strengthened the attack!"],
        ["shelltrap", "The lava strengthened the attack!"],
        ["earthpower", "The lava strengthened the attack!"],
        ["payday", "money money money money money mothafucka"],
        ["makeitrain", "money money money money money mothafucka"],
        ["stompingtantrum", "Wrath of the Dragon!!!"],
        ["diamondstorm", "Sparkling treasure!"],
        ["makeitrain", "Sparkling treasure!"],
        ["powergem", "Sparkling treasure!"]
    ]);
    if (moveMessages.has(move.id)) {
        this.add("-message", moveMessages.get(move.id));
    }
    if (move.id === "smackdown" || move.id === "thousandarrows") {
        this.add("-message", target.name + " was knocked into the lava!");
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    if (move.id === "scaleshot")
        move.selfBoost = { boosts: { spe: 1 } };
    const fire_moves = ["smackdown", "thousandarrows", "continentalcrush", "tectonicrage", "rockclimb", "earthquake"];
    if (fire_moves.includes(move.id)) {
        move.types = [move.type, "Fire"];
    }
    if (move.id === "strength") {
        this.add("-message", "Unrivaled Power!");
        move.types = ["Rock", "Fire"];
    }
},
uncertain: true},
{id: "factoryterrain",
name: "Factory Terrain",
notes: ["Electric attacks gain 1.2× power. Industrial and electrical moves can switch Factory to Short Circuit. Accepts Electric Aura, but it cannot be converted into Full Electric Terrain here."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const quakemoves = ["bulldoze", "fissure", "earthquake", "explosion", "magnitude", "selfdestruct", "tectonicrage", "lightthatburnsthesky", "aurawheel", "discharge", "gigavolthavoc", "iondeluge", "overdrive"];
    const uberboost = ["doubleironbash", "flashcannon", "geargrind", "gyroball", "magnetbomb"];
    const boost = ["superumdmove", "steamroller", "technoblast"];
    if (move.type === "Electric") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.2);
    }
    if (uberboost.includes(move.id)) {
        this.add("-message", "ATTACK SEQUENCE INITIATE.");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    if (boost.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (quakemoves.includes(move.id) || move.id === "superumdmove" && move.category === "Physical") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    return this.chainModify(modifier);
},
uncertain: false},
{id: "fairytaleterrain",
name: "Fairy Tale Terrain",
notes: ["Dragon attacks gain 2× power. Steel becomes super effective against Dragon. Cut, Sacred Sword, Secret Sword and Slash become Steel-type. Fortress Shell grants +1 Defense and Special Defense once per qualifying field."],
onBasePower(basePower, source, target, move) {
    const strengthenedMoves = ["airslash", "ancientpower", "fleurcannon", "leafblade", "magicalleaf", "moongeistbeam", "mysticalfire", "nightslash", "psychocut", "relicsong", "smartstrike", "solarblade", "sparklingaria", "menacingmoonrazemaelstorm", "oceanicoperetta", "kowtowcleave", "aquacutter", "ceaselessedge", "stoneaxe", "behemothblade", "razorshell", "behemothbash"];
    let modifier = 1;
    if (move.type === "Fire") {
        this.add("-message", "The fiery flames became draconified!");
    }
    if (move.type === "Dragon") {
        this.add("-message", "The draconic energy was strengthened by the dead princesses on the field!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    if (move.type === "Fairy") {
        this.add("-message", "The fairy energy was strengthened by the dead dragons on the field!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.type === "Steel") {
        this.add("-message", "The steel energy was strengthened by the dead knights on the field!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (strengthenedMoves.includes(move.id)) {
        this.add("-message", "The move was strengthened by the terrain!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.id === "drainingkiss" || move.id === "mistball") {
        this.add("-message", "The move was strengthened by the terrain!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    return this.chainModify(modifier);
},
onModifyType(move, pokemon) {
    const steelify = ["cut", "sacredsword", "secretsword", "slash"];
    if (steelify.includes(move.id)) {
        move.type = "Steel";
    }
},
onModifyMove(move) {
    if (move.type === "Fire") {
        move.types = [move.type, "Dragon"];
    }
},
uncertain: false},
{id: "forestterrain",
name: "Forest Terrain",
notes: ["Grass attacks gain 1.5× power. Cutting, fire and wind move interactions are listed below. Bloom Doom does not replace Forest with Grassy Terrain."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const igniteMoves = ["infernalrage", "eruption", "firepledge", "flameburst", "heatwave", "incinerate", "lavaplume", "mindblown", "searingshot", "infernooverdrive"];
    const boosted = ["galestrike", "attackorder", "electroweb", "drumbeating", "skittersmack", "pounce"];
    const cutMoves = ["aircutter", "airslash", "breakingswipe", "furycutter", "psychocut", "slash"];
    const hauntedMoves = ["ominouswind", "phantomforce", "shadowforce", "spectralscream", "trickortreat"];
    const nerfed = ["muddywater", "surf"];
    if (move.type === "Grass") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.type === "Bug" && move.category === "Special") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (boosted.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.isMax && move.type === "Water") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    if (nerfed.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
        const marshCounter = move.id === "surf" ? 1 : 2;
        const currentCounter = this.field.terrainState.terrainChanges?.get("swampterrain") ?? 0;
        if (currentCounter + marshCounter >= 3) {
            modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
        }
    }
    if (move.id === "cut") {
        this.add("-message", "A tree slammed down!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    if (cutMoves.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (igniteMoves.includes(move.id) || move.isMax && move.type === "Fire") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    if (hauntedMoves.includes(move.id) || move.id === "curse" && source.types.includes("Ghost")) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    if (move.id === "gravapple") {
        this.add("-message", "The apple did not fall far from the tree.");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    const grassymoves = ["galestrike", "aircutter", "airslash", "breakingswipe", "furycutter", "psychocut", "slash", "cut"];
    if (grassymoves.includes(move.id)) {
        move.types = [move.type, "Grass"];
    }
},
uncertain: true},
{id: "glitchterrain",
name: "Glitch Terrain",
notes: ["Uses its retro category/type rules. Faster attackers gain a critical-hit stage. Psychic is immune to Ghost; Bug/Poison hit each other super effectively; Ice is neutral against Fire; Dragon matchups are neutral; Steel resists Dark/Ghost. Psychic power is 1.2×. Recharge attacks skip recharging after a knockout. Accepts Auras but blocks conversion."],
onBasePower(basePower, source, target, move) {
    if (move.type === "Psychic") {
        this.add("-message", ".0P pl$ nerf!-//");
        return this.chainModify(1.2);
    }
},
onModifyMove(move) {
    const Special = ["Grass", "Fire", "Water", "Electric", "Ice", "Dragon", "Ice", "Dragon", "Psychic", "Dark"];
    const Physical = ["Normal", "Fighting", "Ghost", "Poison", "Bug", "Flying", "Ground", "Rock", "???", "Steel"];
    const nonexistant = ["Fairy"];
    if (move.category !== "Status") {
        if (nonexistant.includes(move.type)) {
            move.type = "Normal";
        }
        if (Special.includes(move.type)) {
            move.category = "Special";
        }
        if (Physical.includes(move.type)) {
            move.category = "Physical";
        }
    }
},
onTryMove(target, source, move) {
    if (move.id === "roar" || move.id === "whirlwind") {
        this.add("-message", "ERROR! MOVE NOT FOUND!");
        return null;
    }
},
uncertain: false},
{id: "hauntedterrain",
name: "Haunted Terrain",
notes: ["Ghost attacks can hit Normal typing. Ghost Pokémon gain 1.3× Defense and Special Defense. Sleeping non-Ghost Pokémon lose 1/16 HP per turn. Accepts Auras; full-field replacement remains restricted."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const wispMoves = ["firespin", "flameburst", "flamecharge", "inferno"];
    const booMoves = ["astonish", "boneclub", "bonerush", "bonemerang"];
    const blessedMoves = ["judgement", "originpulse", "purify", "sacredfire", "dazzlinggleam", "flash"];
    if (move.type === "Ghost") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
        this.add("-message", "The evil aura powered up the attack!");
    }
    if (wispMoves.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
        this.add("-message", "Will-o'-wisps joined the attack...");
    }
    if (booMoves.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
        this.add("-message", "Boo!");
    }
    if (blessedMoves.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    if (move.id === "shadowbone") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.2);
        this.add("-message", "Spooky scary skeletons!");
    }
    return this.chainModify(modifier);
},
uncertain: false},
{id: "holyterrain",
name: "Holy Terrain",
notes: ["Damaging allied attacks are blocked. Normal attacks are super effective against Ghost/Dark typing. Special Fairy/Normal power is 1.5×; Dragon/Psychic power is 1.2×. Ghost and special Dark power is halved."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const strong_boost = ["mysticalfire", "magicalleaf", "ancientpower", "judgment", "deiludicium", "sacredfire", "extremespeed", "sacredsword", "return"];
    const boost = ["multipulse", "psystrike", "aeroblast", "originpulse", "doomdesire", "mistball", "crushgrip", "lusterpurge", "secretsword", "psychoboost", "relicsong", "spacialrend", "hyperspacehole", "roaroftime", "landswrath", "precipiceblades", "dragonascent", "moongeistbeam", "sunsteelstrike", "prismaticlaser", "fleurcannon", "diamondstorm", "genesissupernova", "searingsunrazesmash", "menacingmoonrazemaelstrom"];
    const hauntedMoves = ["ominouswind", "phantomforce", "shadowforce", "spectralscream", "trickortreat"];
    if (move.id === "radiantassault") {
        this.add("-message", "Legendary power accelerated the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if ((move.type === "Fairy" || move.type === "Normal") && move.category === "Special") {
        this.add("-message", "The holy energy resonated with the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.type === "Dragon" || move.type === "Psychic") {
        this.add("-message", "The legendary energy resonated with the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.2);
    }
    if (move.type === "Ghost" || move.category === "Special" && move.type === "Dark") {
        this.add("-message", "The attack was cleansed...");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    }
    if (strong_boost.includes(move.id)) {
        if (move.id === "extremespeed") {
            this.add("-message", "Godspeed!");
        }
        else {
            this.add("-message", "The holy energy resonated with the attack!");
        }
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (hauntedMoves.includes(move.id) || move.id === "curse" && source.types.includes("Ghost")) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    if (boost.includes(move.id)) {
        this.add("-message", "Legendary power accelerated the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    if (!move.ignoreImmunity)
        move.ignoreImmunity = {};
    if (move.ignoreImmunity !== true && move.type === "Normal") {
        move.ignoreImmunity["Normal"] = true;
    }
},
uncertain: false},
{id: "icyterrain",
name: "Icy Terrain",
notes: ["Grounded non-Ice Pokémon lose 25% Speed unless protected by Snow Cloak, Slush Rush, Ice Body, Refrigerate or Spiral Evolution. Ice Pokémon gain 1.5× Defense in hail. Icy Spikes hurt grounded entrants. Heat and underlying water affect field transitions.","Triple Dive leaves Icy Field intact on hit one, breaks it to Water Surface on hit two, and creates Underwater on hit three, subject to field locks."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const igniteMoves = ["infernalrage", "burningjealousy", "eruption", "firepledge", "flameburst", "heatwave", "incinerate", "infernooverdrive", "lavaplume", "magmadrift", "mindblown", "ragingfury", "searingshot"];
    const quakeMoves = ["bulldoze", "earthquake", "fissure", "magnitude", "tectonicrage"];
    const hotWaterMoves = ["scald", "steameruption", "hydrosteam"];
    const hotWaterCount = this.field.terrainState.terrainChanges?.get("icyHotWater") ?? this.field.terrainState.terrainChanges?.get("previousTerrain") ?? 0;
    if (move.type === "Ice") {
        this.add("-message", "The cold strengthened the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.type === "Fire") {
        this.add("-message", "The cold softened the attack...");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    }
    if (hotWaterMoves.includes(move.id)) {
        this.add("-message", "The cold softened the attack...");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
        if (hotWaterCount === 1) {
            modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
        }
    }
    if (move.id === "snipeshot") {
        this.add("-message", "The cold air crystallized the missile");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.2);
    }
    if (move.id === "bittermalice") {
        this.add("-message", "The cold strengthened the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.id === "chillingwater") {
        this.add("-message", "The freezing air boosted the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    const underlyingTerrain = this.field.terrainState.underlyingTerrain || this.field.terrainStack[1]?.id || this.field.terrainState.prevTerrain;
    if ((move.id !== "magmadrift" || !this.field.moveTransitionBlocked(source, move)) && (igniteMoves.includes(move.id) || underlyingTerrain && quakeMoves.includes(move.id) || move.isMax && move.type === "Fire")) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    return this.chainModify(modifier);
},
onModifyMove(move, pokemon) {
    const speedMoves = ["defensecurl", "feint", "iceball", "icespinner", "lunge", "rollout", "spincout", "steamroller"];
    const momentumMove = speedMoves.includes(move.id) || move.priority > 0 && move.flags.contact && move.category === "Physical";
    if (!move.icyMomentum && momentumMove && pokemon.isGrounded()) {
        move.icyMomentum = true;
    }
    if (move.type === "Rock") {
        move.types = Array.from(/* @__PURE__ */ new Set([...move.types || [move.type], "Ice"]));
    }
    if (move.id === "bittermalice" && !move.icyFrostbiteBoosted) {
        move.secondaries ||= [];
        const frostbite = move.secondaries.find((secondary) => secondary.status === "frz");
        if (frostbite) {
            frostbite.chance = (frostbite.chance || 0) + 10;
        }
        else {
            move.secondaries.push({ chance: 10, status: "frz" });
        }
        move.icyFrostbiteBoosted = true;
    }
},
uncertain: true},
{id: "inverseterrain",
name: "Inverse Terrain",
notes: ["Reverses ordinary type effectiveness, turning type immunities into weaknesses. Freeze-Dry retains its special Water interaction. Ground Pokémon remain immune to Thunder Wave."],
uncertain: false},
{id: "mirrorarenaterrain",
name: "Mirror Arena Terrain",
notes: ["Bright Powder/Lax Incense grant +1 evasion on entry; Wide Lens/Zoom Lens grant +1 accuracy and Laser Focus. Positive user accuracy/evasion and negative target accuracy/evasion increase critical-hit stages. Missing physical contact moves can cost 1/4 HP and one positive evasion stage, with armor/protection exceptions."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    let isevasion = false;
    const evasionshredder = ["chargebeam", "solarbeam", "psybeam", "triattack", "icebeam", "hyperbeam", "bubblebeam", "originpulse", "fleurcannon", "moongeistbeam"];
    const minievasionshredder = ["aurorabeam", "dazzlinggleam", "flashcannon", "doomdesire", "lusterpurge", "photongeyser", "prismaticlaser", "signalbeam", "technoblast", "lightthatburnsthesky"];
    const mirrorbreak = ["boomburst", "bulldoze", "earthquake", "explosion", "fissure", "hypervoice", "magnitude", "selfdestruct", "tectonicrage"];
    if (target.boosts.evasion > 0) {
        isevasion = true;
    }
    if (isevasion && evasionshredder.includes(move.id)) {
        this.add("-message", "The enemy's increased evasion concentrated the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    if (move.id === "mirrorshot") {
        this.add("-message", "The mirrors strengthened the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    if (minievasionshredder.includes(move.id)) {
        this.add("-message", "The reflected light was blinding!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (mirrorbreak.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    return this.chainModify(modifier);
},
onModifyMove(move, pokemon, target) {
    let reflected = false;
    const reflectedmoves = ["mirrorshot", "aurorabeam", "dazzlinggleam", "flashcannon", "doomdesire", "lusterpurge", "photongeyser", "prismaticlaser", "signalbeam", "technoblast", "lightthatburnsthesky"];
    if (target && target.boosts.evasion > 0) {
        reflected = true;
    }
    if (move.category === "Special" && (move.target === "normal" || pokemon.foes().length === 1) && !move.flags.contact && reflected || reflectedmoves.includes(move.id)) {
        move.accuracy = true;
    }
},
uncertain: false},
{id: "mountainterrain",
name: "Mountain Terrain",
notes: ["Sustained hail transforms the mountain into Snowy Mountain. Wind, altitude and move-specific modifiers are listed below."],
onBasePower(basePower, source, target, move) {
    const moveToMessageMap = /* @__PURE__ */ new Map([
        ["vitalthrow", target.name + " was thrown partway down the mountain!"],
        ["circlethrow", target.name + " was thrown partway down the mountain!"],
        ["stormthrow", target.name + " was thrown partway down the mountain!"],
        ["mountaingale", "The whole mountain is moving!"],
        ["thunder", "The mountain strengthened the attack!"],
        ["eruption", "The mountain strengthened the attack!"],
        ["avalanche", "The mountain strengthened the attack!"],
        ["hypervoice", "Yodelayheehoo~"]
    ]);
    if (moveToMessageMap.has(move.id)) {
        this.add("-message", moveToMessageMap.get(move.id));
    }
    let modifier = 1;
    const boost = ["vitalthrow", "circlethrow", "stormthrow", "ominouswind", "icywind", "silverwind", "twister", "razorwind", "fairywind", "thunder", "eruption", "avalanche", "hypervoice"];
    const snow = ["blizzard", "glaciate", "subzeroslammer", "mountaingale"];
    if (move.type === "Rock" || move.type === "Flying") {
        this.add("-message", "The field strengthened the move's " + move.type + " typing");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (boost.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (snow.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    return this.chainModify(modifier);
},
uncertain: false},
{id: "murkwatersurfaceterrain",
name: "Murkwater Surface Terrain",
notes: ["Grounded non-Water Pokémon lose 25% Speed unless protected by Surge Surfer, Swift Swim, Limber, Web Assassin or Spiral Evolution. Toxic water damages eligible grounded Pokémon based on Poison effectiveness and 1/8 HP; Dive quadruples it and vulnerable abilities double it."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const strengthenedMoves = ["mudbomb", "mudshot", "mudbarrage", "thousandwaves", "acid", "acidspray", "brine", "smackdown", "wavecrash", "appleacid"];
    const change = ["whirlpool", "blizzard", "subzeroslammer", "glaciate"];
    if (move.type === "Water") {
        this.add("-message", "The water move was aided by the poison!");
        this.add("-message", "The toxic water strengthened the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.type === "Poison") {
        this.add("-message", "The poison in the move was supercharged!");
        this.add("-message", "The toxic water strengthened the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.type === "Electric" && target.isGrounded()) {
        this.add("-message", "The toxic water conducted the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 5325 / 4096);
    }
    if (strengthenedMoves.includes(move.id)) {
        if (move.id === "wavecrash") {
            this.add("-message", "A toxic wave crashes down!");
        }
        else if (move.id === "brine") {
            this.add("-message", "Stinging!");
        }
        else {
            this.add("-message", "The toxic water strengthened the attack!");
        }
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (change.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 5325 / 4096);
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    const waterpoisonMoves = ["mudbomb", "mudshot", "mudbarrage", "thousandwaves"];
    if (move.type === "Water" || waterpoisonMoves.includes(move.id)) {
        move.types = ["Water", "Poison"];
        move.type = "Water";
    }
    if (move.id === "smackdown" || move.id === "appleacid") {
        move.types = [move.type, "Poison"];
    }
    if (move.id === "sludgewave") {
        move.types = [move.type, "Water"];
    }
},
onTryMove(source, target, move) {
    if (move.type === "Ground" && move.category !== "Status" && !(0, import_ground_bone_moves.isGroundBoneMove)(move) || move.id === "sandattack") {
        this.add("-message", "...But there was no solid ground to attack from!");
        return false;
    }
},
uncertain: false},
{id: "newworldterrain",
name: "New World Terrain",
notes: ["Rejects weather and Auras. Grounded Pokémon lose 25% Speed unless protected by Limber, Web Assassin or Spiral Evolution; airborne Pokémon lose 10% Defense and Special Defense except ordinary Gardevoir with Void Veil. Fortress Shell grants +1 Defense and Special Defense once per qualifying field. Terrain Pulse chooses a random type."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const boost = ["aurorabeam", "signalbeam", "flashcannon", "dazzlinggleam", "mirrorshot", "photongeyser", "psystrike", "aeroblast", "sacredfire", "mistball", "lusterpurge", "originpulse", "precipiceblades", "dragonascent", "psychoboost", "roaroftime", "magmastorm", "crushgrip", "judgment", "deiludicium", "seedflare", "shadowforce", "searingshot", "vcreate", "secretsword", "sacredsword", "relicsong", "fusionbolt", "fusionflare", "iceburn", "freezeshock", "boltstrike", "blueflare", "technoblast", "oblivionwing", "landswrath", "thousandarrows", "thousandwaves", "diamondstorm", "steameruption", "coreenforcer", "fleurcannon", "prismaticlaser", "sunsteelstrike", "spectralthief", "moongeistbeam", "multiattack", "mindblown", "plasmafists", "earthpower", "powergem", "eruption", "continentalcrush", "genesissupernova", "soulstealing7starstrike", "searingsunrazesmash", "menacingmoonrazemaelstrom", "astralbarrage", "behemothbash", "behemothblade", "collisioncourse", "doubleironbash", "dragonenergy", "dynamaxcannon", "electrodrift", "eternabeam", "fierywrath", "glaciallance", "ruination", "freezingglare", "terastarstorm", "surgingstrikes", "malignantchain", "tachyoncutter", "mightycleave", "hydrosteam", "thunderclap", "ivycudgel", "psyblade", "sandsearstorm", "wildboltstorm", "springtidestorm", "thundercage", "thunderouskick", "wickedblow", "mirrorbeam"];
    const strong_boost = ["vacuumwave", "dracometeor", "meteormash", "moonblast", "cometpunch", "swift", "meteorbeam", "hyperspacehole", "spacialrend", "hyperspacefury", "ancientpower", "futuredummy", "blackholeeclipse"];
    const weak_nerf = ["bulldoze", "earthquake", "magnitude"];
    if (move.id === "radiantassault") {
        this.add("-message", "The light shone through the infinite darkness!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (boost.includes(move.id)) {
        this.add("-message", "The ethereal energy strengthened the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (strong_boost.includes(move.id)) {
        this.add("-message", "The light shone through the infinite darkness!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    if (move.id === "doomdesire" || move.id === "nostraswish") {
        this.add("-message", "A star came crashing down on " + target.name);
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 4);
    }
    if (weak_nerf.includes(move.id)) {
        this.add("-message", "The unformed land diffused the attack...");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.25);
    }
    if (move.type === "Dark") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
        this.add("-message", "Infinity boosted the attack!");
    }
    return this.chainModify(modifier);
},
uncertain: false},
{id: "rainbowterrain",
name: "Rainbow Terrain",
notes: ["Eligible secondary-effect chances double unless the user has Serene Grace. Special Normal attacks gain 1.5× power and a random additional type. Sleeping Pokémon heal 1/16 HP; Comatose also qualifies unless combined with Magic Guard. Hail and sandstorm remove the field."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const strengthenedMoves = ["aurorabeam", "dazzlinggleam", "dragonpulse", "firepledge", "fleurcannon", "grasspledge", "heartstamp", "hiddenpower", "judgment", "deiludicium", "mirrorbeam", "mistball", "moonblast", "mysticalfire", "oceanicoperetta", "prismaticlaser", "relicsong", "sacredfire", "secretpower", "silverwind", "solarbeam", "solarblade", "sparklingaria", "triattack", "twinkletackle", "waterpledge", "weatherball", "zenheadbutt"];
    const weakenedMoves = ["darkpulse", "nightdaze", "neverendingnightmare", "shadowball"];
    if (move.type === "Normal" && move.category === "Special") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (strengthenedMoves.includes(move.id)) {
        this.add("-message", "The terrain strengthened the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (weakenedMoves.includes(move.id)) {
        this.add("-message", " The terrain weakened the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    }
    if (move.id === "lightthatburnsthesky") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    return this.chainModify(modifier);
},
onModifyMove(move, pokemon) {
    if (move.secondaries && move.id !== "secretpower" && !pokemon.hasAbilityOrPassive("serenegrace")) {
        this.debug("doubling secondary chance");
        for (const secondary of move.secondaries) {
            if (secondary.chance)
                secondary.chance *= 2;
        }
        if (move.self?.chance)
            move.self.chance *= 2;
    }
    if (move.type === "Normal" && move.category === "Special") {
        this.add("-message", "The rainbow augmented the boring, plain move and made it more interesting!");
        const types = ["Normal", "Water", "Fire", "Grass", "Fighting", "Psychic", "Bug", "Flying", "Ground", "Dark", "Fairy", "Poison", "Electric", "Steel", "Ghost", "Dragon", "Ice", "Rock"];
        move.types = [move.type, this.sample(types)];
    }
},
uncertain: false},
{id: "rockyterrain",
name: "Rocky Terrain",
notes: ["Failed contact moves cost the user 1/8 maximum HP unless protected by Rock Head; this includes misses, immunity and protection failures. Raised Defense prevents flinching and blocks bullet and pulse moves, matching local Bulletproof coverage; Substitute also blocks those moves. Flinching costs 1/4 HP unless protected by Steadfast or Sturdy. Rock attacks gain 1.5× power; named move boosts can stack."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const rockymoves = ["bulldoze", "earthquake", "magnitude", "rockclimb", "strength", "accelerock"];
    if (move.type === "Rock") {
        this.add("-message", "The field strengthened the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.id === "rocksmash") {
        this.add("-message", "SMASH'D!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    if (rockymoves.includes(move.id)) {
        this.add("-message", "The rocks strengthened the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    const rockymoves = ["bulldoze", "earthquake", "magnitude", "rockclimb", "strength"];
    if (rockymoves.includes(move.id)) {
        move.types = Array.from(/* @__PURE__ */ new Set([...move.types || [move.type], "Rock"]));
    }
},
uncertain: false},
{id: "shortcircuitterrain",
name: "Short-Circuit Terrain",
notes: ["Electric power depends on the short-circuit cycle. Electric Aura does not add its Electric type bonus here, and cannot convert this field into Full Electric Terrain. Industrial attacks can restore Factory."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const multiplier = [0.8, 1.5, 0.5, 1.2, 2];
    const text = ["Bzzt", "Bzzapp!", "Bzt...", "Bzap!", "BZZZAPP!"];
    const electrified = ["geargrind", "gyroball", "hydrovortex", "magnetbomb", "muddywater", "surf", "flashcannon"];
    const boosted = ["superumdmove", "dazzlinggleam", "hydrovortex", "infernalparade"];
    const shadow = ["darkpulse", "nightdaze", "nightslash", "phantomforce", "shadowball", "shadowbone", "shadowclaw", "shadowforce", "shadowpunch", "shadowsneak"];
    const nerfed = ["lightthatburnsthesky"];
    const fieldchange = ["aurawheel", "chargebeam", "discharge", "gigavolthavoc", "iondeluge", "overdrive", "paraboliccharge", "wildcharge", "risingvoltage"];
    if (move.id === "steelbeam") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.666666);
    }
    if (electrified.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (boosted.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (shadow.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    if (nerfed.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    }
    if (fieldchange.includes(move.id) || move.id === "superumdmove" && move.category === "Special") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    if (move.type === "Electric") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, multiplier[this.ShortCircuitCounter]);
        this.add("-message", text[this.ShortCircuitCounter]);
        this.ShortCircuitCounter += 1;
        this.ShortCircuitCounter %= 5;
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    const electrified = ["flashcannon", "geargrind", "gyroball", "magnetbomb", "muddywater", "surf", "steelbeam", "doubleironbash"];
    if (electrified.includes(move.id)) {
        move.types = [move.type, "Electric"];
    }
    if (move.id === "zapcannon") {
        move.accuracy = 80;
    }
},
uncertain: true},
{id: "snowymountainterrain",
name: "Snowy Mountain Terrain",
notes: ["Snow, wind, ice and mountain move bonuses are listed below. Field-history and weather conditions affect certain attacks."],
onBasePower(basePower, source, target, move) {
    const moveToMessageMap = /* @__PURE__ */ new Map([
        ["vitalthrow", "{1} was thrown partway down the mountain!"],
        ["circlethrow", "{1} was thrown partway down the mountain!"],
        ["stormthrow", "{1} was thrown partway down the mountain!"],
        ["avalanche", "The snow strengthened the attack!"],
        ["powdersnow", "The snow strengthened the attack!"],
        ["icywind", "The frigid wind strengthened the attack!"],
        ["hypervoice", "Yodelayheehoo~"]
    ]);
    if (moveToMessageMap.has(move.id)) {
        this.add("-message", moveToMessageMap.get(move.id));
    }
    let modifier = 1;
    const boost_types = ["Rock", "Ice", "Flying"];
    const boost = ["vitalthrow", "circlethrow", "stormthrow", "ominouswind", "silverwind", "twister", "razorwind", "fairywind", "avalanche", "powdersnow", "hypervoice", "glaciate", "bittermalice"];
    const igniteMoves = ["infernalrage", "eruption", "firepledge", "flameburst", "heatwave", "incinerate", "lavaplume", "mindblown", "searingshot", "infernooverdrive"];
    if (boost_types.includes(move.type)) {
        this.add("-message", "The field strengthened the move's " + move.type + " typing");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.type === "Fire") {
        this.add("-message", "The cold softened the attack");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    }
    if (boost.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (["scald", "steameruption", "hydrosteam"].includes(move.id)) {
        this.add("-message", "The cold softened the attack...");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    }
    if (igniteMoves.includes(move.id) || move.isMax && move.type === "Fire") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    if (this.field.isWeather("deltastream") && ["bleakwindstorm", "sandsearstorm", "wildboltstorm"].includes(move.id)) {
        this.add("-message", "The wind strengthened the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.id === "icywind") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    if (move.type === "Rock") {
        move.types = ["Rock", "Ice"];
    }
},
uncertain: false},
{id: "snowyterrain",
name: "Snowy Terrain",
notes: ["Snowscape creates Snowy Field for 5 turns without hail or Frozen Aura. Ice power is 1.5x and Fire power 0.5x. Grounded non-Ice Pokemon lose 25% Speed except Slush Rush, Ice Body, Snow Cloak and Refrigerate. Ice types gain 1.5x Special Defense in hail. Rain becomes hail at turn end; hail lasts 8 turns. Elemental Seed grants +1 Special Defense, Wish and five-turn Safeguard. Aurora Veil works here. Heating attacks clear the field."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const types = move.types || [move.type];
    if (types.includes("Ice"))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    if (types.includes("Fire"))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    if (["powdersnow", "chillingwater"].includes(move.id))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    if (["bleakwindstorm", "razorwind", "avalanche", "icywind"].includes(move.id))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    if (["scald", "steameruption", "hydrosteam"].includes(move.id))
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    return this.chainModify(modifier);
},
onModifyMove(move) {
    if ([
        "anchorshot",
        "ironhead",
        "irontail",
        "steelroller",
        "gyroball",
        "geargrind",
        "mudbarrage",
        "sandtomb",
        "chillingwater",
        "magnetbomb",
        "metalclaw",
        "doubleironbash",
        "bulletpunch",
        "mudshot",
        "mudbomb",
        "earthquake",
        "gigatonhammer",
        "steelwing",
        "smartstrike",
        "sunsteelstrike",
        "meteormash",
        "magnitude",
        "bulldoze"
    ].includes(move.id)) {
        move.type = "Ice";
        move.types = ["Ice"];
    }
    if (move.id === "bittermalice") {
        move.secondaries ||= [];
        const frostbite = move.secondaries.find((s) => s.status === "frz");
        if (frostbite)
            frostbite.chance = Math.max(10, frostbite.chance || 0);
        else
            move.secondaries.push({ chance: 10, status: "frz" });
    }
},
onAccuracy(accuracy, target, source, move) {
    if (["blizzard", "bleakwindstorm", "icywind", "coldsnap", "frostbreath"].includes(move.id))
        return true;
},
uncertain: false},
{id: "starlightarenaterrain",
name: "Starlight Arena Terrain",
notes: ["Weather can suppress starlight attack bonuses. Fortress Shell grants +1 Defense and Special Defense once per qualifying field. Cosmic and beam move modifiers are listed below."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const boost = ["aurorabeam", "signalbeam", "flashcannon", "lusterpurge", "dazzlinggleam", "mirrorshot", "technoblast", "solarbeam", "photongeyser", "moonblast", "meteorbeam", "mirrorbeam"];
    const strong_boost = ["dracometeor", "meteormash", "cometpunch", "spacialrend", "swift", "hyperspacehole", "hyperspacefury", "moongeistbeam", "sunsteelstrike", "blackholeeclipse", "searingsunrazesmash", "menacingmoonrazemaelstrom"];
    if (this.field.weather === "") {
        if (move.type === "Dark" || move.type === "Psychic") {
            this.add("-message", "The field strengthened the attack!");
            modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
        }
        if (move.type === "Fairy") {
            this.add("-message", "Starlight supercharged the attack!");
            modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, move.id === "nostraswish" ? 2 : 1.3);
        }
        if (move.id === "doomdesire") {
            this.add("-message", "A star came crashing down!");
            modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 4);
        }
        if (boost.includes(move.id)) {
            this.add("-message", "Starlight surged through the attack!");
            modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
        }
        if (strong_boost.includes(move.id)) {
            this.add("-message", "The astral energy boosted the attack!");
            modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
        }
        return this.chainModify(modifier);
    }
},
onModifyMove(move) {
    if (move.type === "Dark") {
        move.types = ["Dark", "Fairy"];
    }
},
uncertain: false},
{id: "superheatedterrain",
name: "Super-Heated Terrain",
notes: ["Hail and snow are removed. Heat, water and steam move effects are listed below."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const scald = ["scald", "steameruption"];
    const steam = ["muddywater", "sparklingaria", "surf", "waterpledge", "waterspout", "hydrovortex", "oceanicoperetta"];
    const igniteMoves = ["infernalrage", "eruption", "explosion", "firepledge", "flameburst", "heatwave", "incinerate", "lavaplume", "mindblown", "searingshot", "selfdestruct", "infernooverdrive"];
    const freeze = ["blizzard", "glaciate", "subzeroslammer"];
    if (move.type === "Fire") {
        this.add("-message", "The attack was super-heated!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.1);
    }
    if (move.type === "Ice") {
        this.add("-message", "The extreme heat softened the attack...");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    }
    if (move.type === "Water" && !(scald.includes(move.id) || steam.includes(move.id))) {
        this.add("-message", "The extreme heat softened the attack...");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.9);
    }
    if (scald.includes(move.id)) {
        this.add("-message", "The field super-heated the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (steam.includes(move.id)) {
        this.add("-message", "Steam shot up from the field!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5625);
    }
    if (igniteMoves.includes(move.id) || freeze.includes(move.id) || move.isMax && move.type === "Fire") {
        igniteMoves.includes(move.id) ? this.add("-message", "The field combusted!") : this.add("-message", "The field cooled off!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    return this.chainModify(modifier);
},
uncertain: false},
{id: "swampterrain",
name: "Swamp Terrain",
notes: ["Eligible grounded Pokémon lose Speed each turn; trapped Pokémon lose more. Sleeping/Comatose Pokémon take residual damage unless protected by Magic Guard, doubled when trapped. Certain trapping effects also lower random stats. Ability/item exceptions and accumulated swamp history affect outcomes."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const strengthenedMoves = ["thousandarrows", "smackdown", "brine", "gunkshot", "hydrovortex", "mudbarrage", "mudbomb", "mudshot", "mudbarrage", "muddywater", "savagespinout", "sludgewave"];
    const weakenedMoves = ["bulldoze", "earthquake", "magnitude"];
    const igniteMoves = ["infernalrage", "eruption", "firepledge", "flameburst", "heatwave", "incinerate", "lavaplume", "mindblown", "searingshot", "infernooverdrive"];
    if (move.type === "Poison" && target.isGrounded()) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.type === "Bug") {
        this.add("-message", "Bugs are swarming everywhere!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    if (move.type === "Grass") {
        this.add("-message", "Thick mangroves line the area!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    if (move.type === "Water") {
        this.add("-message", "The dampness strengthened the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    if (move.type === "Fire") {
        this.add("-message", "The dampness weakened the flame...");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.8);
    }
    if (strengthenedMoves.includes(move.id)) {
        this.add("-message", "The murk strengthened the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (weakenedMoves.includes(move.id)) {
        this.add("-message", "The attack dissipated in the soggy ground...");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.25);
    }
    if (igniteMoves.includes(move.id) || move.isMax && move.type === "Fire") {
        const revertCounter = move.id === "infernooverdrive" ? 2 : 1;
        const currentCounter = this.field.terrainState.terrainChanges?.get("revertTerrain") ?? 0;
        if (currentCounter + revertCounter >= 3) {
            modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
        }
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    const powderMoves = ["poisonpowder", "stunspore", "sleeppowder"];
    if (powderMoves.includes(move.id)) {
        move.accuracy = 100;
    }
    if (move.id === "thousandarrows" || move.id === "smackdown") {
        move.types = [move.type, "Water"];
    }
    const boostSap = ["attackorder", "strengthsap", "stringshot"];
    const chosenBoost = {};
    const stats = ["accuracy", "evasion", "spa", "spe", "spd", "atk", "def"];
    const randomStat = this.sample(stats);
    if (randomStat)
        chosenBoost[randomStat] = -1;
    if (boostSap.includes(move.id) || move.drain !== void 0) {
        move.secondaries = [];
        move.secondaries.push({
            chance: 100,
            boosts: chosenBoost
        });
    }
},
onTryMove(target, source, effect) {
    if (["explosion", "mindblown", "selfdestruct"].includes(effect.id)) {
        this.attrLastMove("[still]");
        this.add("-message", "The terrain stifled the move!");
        return false;
    }
},
uncertain: true},
{id: "midnightzoneterrain",
name: "Midnight Zone Terrain",
notes: ["Rejects Auras and weather. Non-Water Pokémon have quarter Speed unless protected by Steelworker, Schooling or Swift Swim. Water Pokémon heal 1/16 HP; Water Absorb/Dry Skin add 1/10 healing. Unprotected non-Water/non-Ghost Pokémon suffer pressure damage: 1/4 HP for Steel/Ice/Fire/Rock, otherwise 1/10. Only non-whitelisted physical attacks receive the field damage reduction. Escape moves can return the battle to Underwater.","Shadow Force creates this field after dealing positive HP or Substitute damage, for 5 turns or 8 with Amplifield Rock; the charge turn does not create it."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const messages = {
        Water: "The water strengthened the attack!",
        Ice: "Warmth has been eliminated...!",
        Dark: "Darkness gathers...!",
        Electric: "The water super-conducted the attack!"
    };
    if (messages[move.type]) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, move.type === "Electric" ? 1.2 : 1.5);
        this.add("-message", messages[move.type]);
    }
    if (move.midnightGround || move.type === "Ground") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.2);
        this.add("-message", "The trenches strengthened the attack.");
    }
    if (move.id === "waterpulse") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
        this.add("-message", "Jet-streamed!");
    }
    if (["anchorshot", "dragondarts"].includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
        this.add("-message", "From the depths!");
    }
    if (["darkpulse", "nightdaze", "nightslash", "shadowball", "shadowforce", "shadowclaw", "shadowpunch", "shadowbone"].includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.2);
        this.add("-message", "The lightless abyss boosted the attack.");
    }
    if (["signalbeam", "doomdesire", "flashcannon", "lusterpurge", "dazzlinggleam", "mirrorshot", "technoblast", "powergem", "moongeistbeam", "menacingmoonrazemaelstrom"].includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
        this.add("-message", "The light disappeared in the dark...");
    }
    if (move.category === "Physical" && !source.hasType("Water") && !source.hasAbilityOrPassive(["steelworker", "schooling", "swiftswim"])) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.33);
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    if (move.category === "Status")
        return;
    if (move.type === "Dark") {
        move.secondaries ||= [];
        move.secondaries.push({ chance: 30, onHit(target, source) {
                if (this.boost({ spa: -1 }, target, source)) {
                    this.add("-message", `${target.name} became disorientated by the thick darkness!`);
                }
            } });
        if (move.category === "Special") {
            move.onEffectiveness = function (typeMod, target, type) {
                return this.dex.getEffectiveness("Water", type);
            };
        }
    }
    if (move.type === "Ground" && !(0, import_ground_bone_moves.isGroundBoneMove)(move)) {
        move.midnightGround = true;
        move.type = "Water";
        delete move.types;
    }
    else if (["dragondarts", "gravapple"].includes(move.id)) {
        move.type = "Water";
        delete move.types;
    }
},
onAccuracy(accuracy, target, source) {
    if (source.hasAbilityOrPassive("illuminate"))
        return true;
},
onTryMove(pokemon, target, move) {
    if (move.type === "Fire") {
        this.add("-message", "...But the attack was doused instantly!");
        return false;
    }
    if (["sunnyday", "raindance", "sandstorm", "hail", "snowscape", "chillyreception"].includes(move.id)) {
        this.add("-message", "You're too deep to notice the weather!");
        return false;
    }
    if (["spikes", "stealthrock", "stickyweb", "toxicspikes", "stoneaxe", "ceaselessedge"].includes(move.id)) {
        this.add("-message", "But they sank into the trenches...");
        return false;
    }
    if (["defog", "tarshot"].includes(move.id)) {
        this.add("-message", "But it failed!");
        return false;
    }
},
uncertain: false},
{id: "underwaterterrain",
name: "Underwater Terrain",
notes: ["Rejects Auras and weather. Non-Water Pokémon generally have half Speed, with ability exceptions. Water attacks are neutral against Water typing. Water-weak Pokémon take effectiveness-scaled residual damage unless protected. Tar Shot washes off; entry hazards are swept away. Gravity, a landed Phantom Force, or certain Dark moves lead to Midnight Zone.","Triple Dive has a named 1.5x power bonus, stacking with the generic Water boost. Its first hit resurfaces, second returns Underwater and third stays there."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const change = ["bounce", "dive", "skydrop", "fly", "aciddownpour"];
    if (move.id === "waterpulse" || move.id === "jetpunch") {
        this.add("-message", "Jet-streamed!");
    }
    if (move.type === "Electric") {
        this.add("-message", "The water super-conducted the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    if (move.id === "anchorshot" || move.id === "dragondarts") {
        this.add("-message", "From the depths!!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    if (move.id === "tripledive")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    if (move.id === "waterpulse") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.type === "Water") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.category === "Physical" && move.type !== "Water" && !source.hasType("Water") && !source.hasAbilityOrPassive("steelworker") && !source.hasAbilityOrPassive("elevate") && !source.hasAbilityOrPassive("schooling") && !source.hasAbilityOrPassive("swiftswim")) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    }
    if (source.hasAbilityOrPassive("propellertail") && move.priority > 0) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (change.includes(move.id) || this.field.terrainState.terrainChanges?.get("sludgewave") === 1 && move.id === "sludgewave") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    if (move.type === "Ground" && !(0, import_ground_bone_moves.isGroundBoneMove)(move)) {
        move.types = [move.type, "Water"];
    }
    if (move.id === "dragondarts" || move.id === "gravapple") {
        move.type = "Water";
        delete move.types;
    }
},
onAccuracy(accuracy, target, source, move) {
    if (move.type === "Electric" && typeof accuracy === "number") {
        return true;
    }
},
onTryMove(source, target, move) {
    if (move.id === "tarshot") {
        this.add("-message", "The tar washed off instantly!");
        return false;
    }
    if (move.id === "spicyextract") {
        this.add("-message", "The extract washed away!");
        return false;
    }
    if (["sunnyday", "hail", "sandstorm", "raindance"].includes(move.id)) {
        this.add("-message", "You're too deep to notice the weather!");
        return false;
    }
    if (move.type === "Fire") {
        this.add("-message", "...But the attack was doused instantly!");
        return false;
    }
},
uncertain: true},
{id: "volcanicterrain",
name: "Volcanic Terrain",
notes: ["Prevents freezing and removes hail. Grounded unprotected non-Fire Pokémon take Fire-effectiveness-scaled residual damage based on 1/8 HP, with doubled damage for vulnerable abilities/Tar Shot. Rain or sandstorm turns it into Cave. Blazing Mane grants +1 Speed on entry."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    if (move.id === "etherealtempest") {
        this.add("-message", "The volcanic air strengthened the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    const caveMoves = ["sandtomb", "scorchingsands", "sandsearstorm", "defog", "gust", "winddance", "airstreamassault", "hurricane", "razorwind", "tailwind", "twister", "whirlwind", "muddywater", "sparklingaria", "watersport", "surf", "waterpledge", "sludgewave", "gmaxwindrage"];
    const caveZMoves = ["continentalcrush", "supersonicskystrike", "hydrovortex", "aciddownpour"];
    const dragonMove = ["dragonpulse", "dragonenergy"];
    const uberDragon = ["devastatingdrake", "dracometeor", "coreenforcer"];
    if (source.isGrounded() && move.type === "Fire") {
        this.add("-message", "The blaze amplified the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (target.isGrounded() && move.type === "Grass" || move.type === "Ice") {
        this.add("-message", "The blaze softened the attack...");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    }
    if (move.type === "Water") {
        this.add("-message", "The attack evaporated!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.75);
    }
    if (["clearsmog", "smog"].includes(move.id)) {
        this.add("-message", "The flames spread from the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    if (["rockslide", "smackdown", "thousandarrows"].includes(move.id)) {
        this.add("-message", `${target.name} was knocked into the flames!`);
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.id === "infernalparade") {
        this.add("-message", "The flames spread from the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (caveZMoves.includes(move.id) || caveMoves.includes(move.id) && this.field.terrainState.terrainChanges?.get("caveterrain") === 1) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    if (dragonMove.includes(move.id) || uberDragon.includes(move.id) && this.field.terrainState.terrainChanges?.get("dragonsdenterrain") === 1) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3);
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    if (move.type === "Rock" || ["clearsmog", "smog", "smackdown", "thousandarrows", "rockslide"].includes(move.id)) {
        move.types = [move.type, "Fire"];
    }
},
uncertain: true},
{id: "wastelandterrain",
name: "Wasteland Terrain",
notes: ["Hazards erupt as turn effects: Toxic Spikes poison and deal 1/8 HP to eligible grounded targets; Spikes deal 1/3 HP; Sticky Web lowers Speed four stages; Stealth Rock deals Rock-effectiveness-scaled damage based on 1/4 HP. Semi-invulnerability and type/grounding rules apply."],
onBasePower(basePower, source, pokemon, move) {
    let modifier = 1;
    const boost = ["mudbomb", "mudshot", "mudbarrage", "powerwhip", "vinewhip"];
    const miniboost = ["gunkshot", "octazooka", "sludge", "sludgebomb", "sludgewave"];
    const weak = ["bulldoze", "earthquake", "magnitude"];
    if (boost.includes(move.id)) {
        this.add("-message", "The waste joined the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, pokemon, 1.5);
    }
    if (miniboost.includes(move.id)) {
        this.add("-message", "The waste did it for the vine!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, pokemon, 1.2);
    }
    if (weak.includes(move.id)) {
        this.add("-message", "Wibble-wibble wobble-wobb...");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, pokemon, 0.25);
    }
    if (move.id === "spitup") {
        this.add("-message", "BLEAAARGGGGH!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, pokemon, 2);
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    const poisoned = ["mudbomb", "mudshot", "mudbarrage"];
    if (poisoned.includes(move.id)) {
        move.types = [move.type, "Poison"];
    }
},
uncertain: false},
{id: "watersurfaceterrain",
name: "Water Surface Terrain",
notes: ["Grounded non-Water Pokémon lose 25% Speed unless protected by Swift Swim, Surge Surfer, Limber, Web Assassin or Spiral Evolution. Tar Shot washes off. Spikes/Toxic Spikes sink. Accepts Auras, but Gravity sinks the field to Underwater and removes them.","Triple Dive has a named 1.5x power bonus, stacking with the generic Water boost. Its second successful hit creates Underwater (third when starting on Icy Field)."],
onBasePower(basePower, source, target, move) {
    let modifier = 1;
    const change = ["dive", "gravity", "aciddownpour", "blizzard", "subzeroslammer", "glaciate", "gravapple"];
    const strengthenedMoves = ["dive", "muddywater", "surf", "whirlpool", "hydrovortex", "splishysplash"];
    const individualBoostedMoves = ["whirlpool", "surf", "muddywater", "dive", "sludgewave", "octazooka", "originpulse", "hydrovortex"];
    if (move.id === "tripledive")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    if (move.type === "Water") {
        this.add("-message", "The water strengthened the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (move.id === "anchorshot" || move.id === "dragondarts") {
        this.add("-message", "From the depths!!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    if (strengthenedMoves.includes(move.id)) {
        this.add("-message", "The attack rode the current!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (individualBoostedMoves.includes(move.id)) {
        if (!strengthenedMoves.includes(move.id))
            this.add("-message", "The attack rode the current!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.2);
    }
    if (target.isGrounded() && move.type === "Electric") {
        this.add("-message", "The water conducted the attack!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (target.isGrounded() && move.type === "Fire") {
        this.add("-message", "The water deluged the attack...");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 0.5);
    }
    if (move.id === "wavecrash") {
        this.add("-message", "The attack rode the current!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 2);
    }
    if (source.hasAbilityOrPassive("propellertail") && move.priority > 0) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5);
    }
    if (change.includes(move.id) || this.field.terrainState.terrainChanges?.get("sludgewave") === 1 && move.id === "sludgewave") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 5325 / 4096);
    }
    return this.chainModify(modifier);
},
onTryMove(source, target, move) {
    if (move.type === "Ground" && move.category !== "Status" && !(0, import_ground_bone_moves.isGroundBoneMove)(move) || move.id === "sandattack") {
        this.add("-message", "...But there was no solid ground to attack from!");
        return false;
    }
},
uncertain: true},
{id: "electricterrain",
name: "Electric Terrain",
notes: ["Grounded Pokémon cannot be put to sleep or affected by Yawn. Electric moves gain 1.5× power for grounded, non-semi-invulnerable users. Quark Drive is active."],
onBasePower(basePower, attacker, defender, move) {
    let modifier = 1;
    const electrified = ["explosion", "hurricane", "muddywater", "selfdestruct", "smackdown", "thousandarrows", "surf", "overdrive", "wildboltstorm"];
    if (move.type === "Electric" && attacker.canBenefitFromTerrain() && !attacker.isSemiInvulnerable()) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, attacker, defender, 1.5);
    }
    if (move.id === "magnetbomb") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, attacker, defender, 2);
    }
    if (electrified.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, attacker, defender, 1.5);
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    const electrified = ["explosion", "hurricane", "muddywater", "overdrive", "selfdestruct", "smackdown", "thousandarrows", "surf", "wildboltstorm", "hydrovortex"];
    if (electrified.includes(move.id)) {
        move.types = [move.type, "Electric"];
    }
},
uncertain: false},
{id: "grassyterrain",
name: "Grassy Terrain",
notes: ["Grounded, non-semi-invulnerable Pokémon recover 1/16 maximum HP each turn. Grass moves gain 1.5× power for grounded users. Earthquake, Bulldoze, Magnitude, Surf and Muddy Water are weakened. Absorb, Mega Drain, Giga Drain and Horn Leech drain 75%. Fire, poison and flooding moves can transform the field."],
onBasePower(basePower, attacker, defender, move) {
    const igniteMoves = ["eruption", "firepledge", "flameburst", "heatwave", "incinerate", "lavaplume", "mindblown", "searingshot", "infernooverdrive"];
    const windyMoves = ["fairywind", "silverwind", "grassknot", "icywind", "ominouswind", "razorwind", "twister"];
    const weakenedMoves = ["earthquake", "bulldoze", "magnitude", "muddywater", "surf"];
    let modifier = 1;
    if (weakenedMoves.includes(move.id)) {
        this.debug("move weakened by grassy terrain");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, attacker, defender, 0.5);
    }
    if (move.type === "Grass" && attacker.canBenefitFromTerrain()) {
        this.debug("grassy terrain boost");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, attacker, defender, 1.5);
    }
    if (move.type === "Fire" && defender.isGrounded()) {
        this.debug("grassy terrain boost");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, attacker, defender, 1.5);
    }
    if (windyMoves.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, attacker, defender, 1.5);
        this.add("-message", "The wind picked up strength from the field!");
    }
    if (igniteMoves.includes(move.id) && !this.field.isWeather(["raindance", "primordealsea"]) && !this.field.pseudoWeather["watersport"] || move.isMax && move.type === "Fire") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, attacker, defender, 1.3);
    }
    if (move.id === "sludgewave" || move.id === "aciddownpour")
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, attacker, defender, 1.3);
    if (move.id === "muddywater" || move.id === "surf") {
        const marshCounter = move.id === "muddywater" ? 2 : 1;
        const currentCounter = this.field.terrainState.terrainChanges?.get("swampterrain") ?? 0;
        if (currentCounter + marshCounter >= 3) {
            modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, attacker, defender, 1.3);
        }
    }
    return this.chainModify(modifier);
},
onModifyMove(move) {
    const drainMoves = ["absorb", "gigadrain", "megadrain", "hornleech"];
    if (drainMoves.includes(move.id)) {
        move.drain = [3, 4];
    }
},
uncertain: true},
{id: "mistyterrain",
name: "Misty Terrain",
notes: ["Fairy Pokémon gain 1.5× Special Defense. Grounded, non-semi-invulnerable Pokémon are protected from status and confusion. Fairy moves gain 1.5× power; Dragon moves are halved. Explosion, Self-Destruct and Mind Blown fail. Poisonous moves can turn the field corrosive; wind moves can clear it."],
onBasePower(basePower, attacker, defender, move) {
    const strMoves = ["aurasphere", "clearsmog", "doomdesire", "icywind", "magicalleaf", "mistball", "moongeistbeam", "mysticalfire", "silverwind", "smog", "springtidestorm", "steameruption", "strangesteam"];
    const weakMoves = ["shadowball", "nightdaze", "darkpulse"];
    const corrosiveMoves = ["smog", "clearsmog", "poisongas", "aciddownpour"];
    const windyMoves = ["defog", "gust", "hurricane", "razorwind", "tailwind", "twister", "whirlwind", "supersonicskystrike", "gmaxwindrage"];
    let modifier = 1;
    if (move.type === "Dragon") {
        this.debug("misty terrain weaken");
        this.add("-message", "The draconic energy was leeched by the terrain!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, attacker, defender, 0.5);
    }
    if (move.type === "Fairy") {
        this.add("-message", "The mist buoyed the fairy type move!");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, attacker, defender, 1.5);
    }
    if (weakMoves.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, attacker, defender, 0.5);
    }
    if (strMoves.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, attacker, defender, 1.5);
    }
    if (move.id === "mistyexplosion") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, attacker, defender, 2);
    }
    if (corrosiveMoves.includes(move.id) && this.field.terrainState.terrainChanges?.get("corrosivemistterrain") === 1 || move.id === "aciddownpour") {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, attacker, defender, 1.3);
    }
    if (windyMoves.includes(move.id)) {
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, attacker, defender, 1.3);
    }
    return this.chainModify(modifier);
},
onTryMove(target, source, effect) {
    if (["explosion", "mindblown", "selfdestruct"].includes(effect.id)) {
        this.attrLastMove("[still]");
        this.add("-message", "The terrain stifled the move!");
        return null;
    }
},
uncertain: true},
{id: "psychicterrain",
name: "Psychic Terrain",
notes: ["Protects grounded, non-semi-invulnerable targets from opposing priority attacks; allies, self-targeting moves and redirection moves are exempt. Grounded Psychic attacks gain 1.5× power. Telepathy doubles Speed. Grounded Expanding Force receives its own additional 1.5× power bonus and targets all adjacent opponents."],
onBasePower(basePower, attacker, defender, move) {
    const strengthenedMoves = ["aurasphere", "hex", "magicalleaf", "mindblown", "moonblast", "mysticalfire"];
    let modifier = 1;
    if (move.type === "Psychic" && attacker.canBenefitFromTerrain() && !attacker.isSemiInvulnerable()) {
        this.debug("psychic terrain boost");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, attacker, defender, 1.5);
    }
    if (strengthenedMoves.includes(move.id)) {
        this.debug("psychic terrain boost");
        modifier *= (0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, attacker, defender, 1.5);
    }
    return this.chainModify(modifier);
},
uncertain: false}
];
const BattleFieldMoveRules = {"acidarmor": {onModifyMove(move) {
      if (this.field.isTerrain("corrosiveterrain") || this.field.isTerrain("corrosivemistterrain") || this.field.isTerrain(["fairytaleterrain", "murkwatersurfaceterrain"])) {
        move.boosts = {
          def: 3
        };
      }
    },
base: {"boosts":{"def":2},"critRatio":1},
uncertain: false},
"aciddownpour": {onModifyMove(move) {
      if (this.field.isTerrain("wastelandterrain")) {
        move.secondaries = [
          {
            chance: 25,
            status: "frz"
          },
          {
            chance: 25,
            status: "brn"
          },
          {
            chance: 25,
            status: "psn"
          },
          {
            chance: 25,
            status: "par"
          }
        ];
      }
    },
base: {"critRatio":1},
uncertain: false},
"acrobatics": {basePowerCallback(pokemon, target, move) {
      if (pokemon.item && (0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields")) return move.basePower;
      if (!pokemon.item || this.field.isTerrain("bigtopterrain")) {
        this.debug("BP doubled for no item");
        return move.basePower * 2;
      }
      return move.basePower;
    },
base: {"critRatio":1},
uncertain: false},
"aromaticmist": {onModifyMove(move) {
      if (this.field.isTerrain("mistyterrain")) {
        move.boosts = {
          spd: 2
        };
      }
    },
base: {"boosts":{"spd":1},"critRatio":1},
uncertain: false},
"atlantiswall": {onModifyPriority(priority) {
      if (this.field.isTerrain(["watersurfaceterrain", "underwaterterrain", "mistyterrain", "murkwatersurfaceterrain", "midnightzoneterrain"])) {
        return priority + 1;
      }
    },
base: {"critRatio":1},
uncertain: false},
"autotomize": {onModifyMove(move) {
      if (this.field.isTerrain("factoryterrain")) {
        move.boosts = {
          spe: 3
        };
      }
    },
base: {"boosts":{"spe":2},"critRatio":1},
uncertain: false},
"baddybad": {onModifyMove(move) {
      if (this.field.isTerrain("mirrorarenaterrain")) {
        move.self = {
          boosts: {
            evasion: 1
          },
          sideCondition: "reflect"
        };
      }
    },
base: {"self":{"sideCondition":"reflect"},"critRatio":1},
uncertain: false},
"barbbarrage": {onBasePower(basePower, pokemon, target) {
      if ((0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields") && !(target.status || target.hasAbility("comatose"))) return;
      if (target.status || target.hasAbility("comatose") || this.field.isTerrain(["corrosivemistterrain", "murkwatersurfaceterrain", "corrosiveterrain", "wastelandterrain"])) {
        return this.chainModify(2);
      }
    },
base: {"secondaries":[{"chance":50,"status":"psn"}],"critRatio":1},
uncertain: false},
"bittermalice": {onModifyMove(move) {
      if (this.field.isTerrain("hauntedterrain")) {
        move.secondaries = [];
        move.secondaries.push(
          {
            chance: 100,
            boosts: {
              spa: -1
            }
          },
          {
            chance: 30,
            status: "frz"
          }
        );
      }
    },
base: {"secondaries":[{"chance":30,"status":"frz"}],"critRatio":1},
uncertain: false},
"bleakwindstorm": {onModifyMove(move, pokemon, target) {
      if (target && (["raindance", "primordialsea", "hail", "snow"].includes(target.effectiveWeather()) || this.field.isTerrain(["coldeclipseterrain", "snowymountainterrain"]))) {
        move.accuracy = true;
      }
    },
base: {"secondaries":[{"chance":30,"status":"frz"}],"critRatio":1},
uncertain: false},
"blizzard": {onModifyMove(move) {
      if (this.field.isWeather(["hail", "snow"]) || this.field.isTerrain("coldeclipseterrain")) {
        move.accuracy = true;
      } else if (this.field.isTerrain("glitchterrain")) {
        move.accuracy = 90;
      }
    },
base: {"secondaries":[{"chance":10,"status":"frz"}],"critRatio":1},
uncertain: false},
"bloomdoom": {onBasePower(basePower, source, target, move) {
      if (this.field.canSetTerrain("grassyterrain", null, move) && !this.field.isTerrain("forestterrain"))
        return this.chainModify(1.3);
    },
base: {"critRatio":1},
uncertain: false},
"calmmind": {onModifyMove(move) {
      if (this.field.isTerrain(["psychicterrain", "ashenbeachterrain", "chessboardterrain"])) {
        move.boosts = {
          spa: 2,
          spd: 2
        };
      }
    },
base: {"boosts":{"spa":1,"spd":1},"critRatio":1},
uncertain: false},
"charge": {onModifyMove(move) {
      if (this.field.isTerrain("electricterrain")) {
        move.boosts = {
          spd: 2
        };
      }
    },
base: {"boosts":{"spd":1},"volatileStatus":"charge","critRatio":1},
uncertain: false},
"chillingwater": {onModifyMove(move) {
      if (this.field.isWeather(["hail", "snow"]) || this.field.isTerrain("coldeclipseterrain")) {
        move.secondaries = [];
        move.secondaries.push({
          chance: 100,
          boosts: {
            atk: -2
          }
        });
      }
    },
base: {"secondaries":[{"chance":100,"boosts":{"atk":-1}}],"critRatio":1},
uncertain: false},
"clangoroussoul": {onModifyMove(move) {
      if (this.field.isTerrain("bigtopterrain")) {
        move.boosts = {
          atk: 2,
          def: 2,
          spa: 2,
          spd: 2,
          spe: 2
        };
      }
    },
base: {"critRatio":1},
uncertain: false},
"coaching": {onModifyMove(move) {
      if (this.field.isTerrain("ashenbeachterrain")) {
        move.boosts = {
          atk: 2,
          def: 2
        };
      }
    },
base: {"boosts":{"atk":1,"def":1},"critRatio":1},
uncertain: false},
"coil": {onModifyMove(move) {
      if (this.field.isTerrain("grassyterrain") || this.field.isTerrain("dragonsdenterrain")) {
        move.boosts = {
          atk: 2,
          def: 2,
          accuracy: 2
        };
      }
    },
base: {"boosts":{"atk":1,"def":1,"accuracy":1},"critRatio":1},
uncertain: false},
"coldsnap": {onModifyMove(move, source, target) {
      if (source.hasType("Ghost")) {
        move.accuracy = true;
        return;
      }
      if (target && (this.field.isWeather(["hail", "snow"]) || this.field.isTerrain(["coldeclipseterrain", "icyterrain"]) || source.hasType("Ice"))) {
        move.accuracy = 100;
      }
    },
base: {"critRatio":1},
uncertain: false},
"cosmicpower": {onModifyMove(move) {
      if (this.field.isTerrain(["mistyterrain", "psychicterrain", "rainbowterrain", "holyterrain", "newworldterrain", "starlightarenaterrain"])) {
        move.boosts = {
          def: 2,
          spd: 2
        };
      }
    },
base: {"boosts":{"def":1,"spd":1},"critRatio":1},
uncertain: false},
"cottonspore": {onModifyMove(move) {
      if (this.field.isTerrain("grassyterrain")) {
        move.boosts = {
          spe: -4
        };
      }
    },
base: {"boosts":{"spe":-2},"critRatio":1},
uncertain: false},
"darkvoid": {onModifyMove(move, source, target) {
      if (source.species.id === "banettemega" && source.hasAbility("cursedmarionette")) {
        move.accuracy = 90;
      }
      if (target && (this.field.isTerrain("darkcrystalcavernterrain") || this.field.isTerrain("newworldterrain") || this.field.isTerrain("coldeclipseterrain"))) {
        move.accuracy = 100;
      }
    },
base: {"critRatio":1},
uncertain: false},
"defendorder": {onModifyMove(move) {
      if (this.field.isTerrain("forestterrain")) {
        move.boosts = {
          def: 2,
          spd: 2
        };
      }
    },
base: {"boosts":{"def":1,"spd":1},"heal":[1,4],"critRatio":1},
uncertain: false},
"direclaw": {onModifyMove(move) {
      if (this.field.isTerrain("wastelandterrain")) {
        move.secondaries = [{
          chance: 100,
          onHit(target, source) {
            const result = this.random(3);
            if (result === 0) {
              target.trySetStatus("psn", source);
            } else if (result === 1) {
              target.trySetStatus("par", source);
            } else {
              target.trySetStatus("slp", source);
            }
          }
        }];
      }
    },
base: {"secondaries":[{"chance":30}],"critRatio":2},
uncertain: false},
"doomdesire": {onModifyMove(move) {
      if (this.field.isTerrain("newworldterrain") || this.field.isTerrain("starlightarenaterrain")) {
        move.types = [move.type, "Fire"];
      }
    },
base: {"critRatio":1},
uncertain: false},
"doubleteam": {onModifyMove(move) {
      if (this.field.isTerrain("mirrorarenaterrain")) {
        move.boosts = {
          evasion: 2
        };
      }
    },
base: {"boosts":{"evasion":1},"critRatio":1},
uncertain: false},
"dragondance": {onModifyMove(move) {
      if (this.field.isTerrain("bigtopterrain") || this.field.isTerrain("dragonsdenterrain")) {
        move.boosts = {
          atk: 2,
          spe: 2
        };
      }
    },
base: {"boosts":{"atk":1,"spe":1},"critRatio":1},
uncertain: false},
"dragonrage": {onModifyMove(move) {
      if (this.field.isTerrain("coldeclipseterrain") || this.field.isAura("frozenaura")) {
        move.damage = 140;
      }
    },
base: {"critRatio":1},
uncertain: false},
"dragonrush": {onModifyMove(move) {
      if (this.field.isTerrain("dragonsdenterrain")) {
        move.accuracy = 100;
      }
    },
base: {"secondaries":[{"chance":30,"volatileStatus":"flinch"}],"critRatio":2},
uncertain: false},
"eerieimpulse": {onModifyMove(move) {
      if (this.field.isTerrain("electricterrain")) {
        move.boosts = {
          spa: -3
        };
      }
    },
base: {"boosts":{"spa":-2},"critRatio":1},
uncertain: false},
"electroweb": {onModifyMove(move) {
      if (this.field.isTerrain("electricterrain")) {
        move.secondaries = [];
        move.secondaries.push({
          chance: 100,
          boosts: {
            spe: -2
          }
        });
      }
    },
base: {"secondaries":[{"chance":100,"boosts":{"spe":-1}}],"critRatio":1},
uncertain: false},
"esperwing": {onModifyMove(move) {
      if (this.field.isTerrain("psychicterrain")) {
        move.secondaries = [];
        move.secondaries.push({
          chance: 100,
          self: {
            boosts: {
              spe: 2
            }
          }
        });
      }
    },
base: {"secondaries":[{"chance":100,"self":{"boosts":{"spe":1}}}],"critRatio":2},
uncertain: false},
"expandingforce": {onModifyMove(move, source, target) {
      if (this.field.isAura("psychicterrain") || this.field.isTerrain("psychicterrain") && source.canBenefitFromTerrain()) {
        move.target = "allAdjacentFoes";
      }
    },
onBasePower(basePower, source, target) {
      if ((0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields") && !this.field.isAura("psychicterrain")) return;
      if (this.field.isTerrainOrAura("psychicterrain") && source.canBenefitFromTerrain()) {
        this.debug("terrain buff");
        return this.chainModify(1.5);
      }
    },
base: {"critRatio":1},
uncertain: false},
"falsesurrender": {onModifyMove(move) {
      if (this.field.isTerrain("chessboardterrain")) {
        move.volatileStatus = "taunt";
      }
    },
base: {"critRatio":1},
uncertain: false},
"featherdance": {onModifyMove(move) {
      if (this.field.isTerrain("bigtopterrain")) {
        move.boosts = {
          atk: -3
        };
      }
    },
base: {"boosts":{"atk":-2},"critRatio":1},
uncertain: false},
"firepledge": {onBasePower(basePower, source, target) {
      if ((0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields")) return;
      if (this.field.terrainState.terrainChanges?.get("waterpledge") === 1 || this.field.terrainState.terrainChanges?.get("grasspledge") === 1) {
        return this.chainModify(1.3);
      }
    },
base: {"critRatio":1},
uncertain: true},
"firespin": {onModifyMove(move) {
      if (this.field.isTerrain("hauntedterrain")) {
        move.target = "allAdjacentFoes";
      }
      if (this.field.isTerrain("volcanicterrain")) {
        move.secondaries = [];
        move.secondaries.push({
          chance: 100,
          status: "brn"
        });
      }
    },
base: {"volatileStatus":"partiallytrapped","critRatio":1},
uncertain: false},
"flash": {onModifyMove(move) {
      if (this.field.isTerrain(["shortcircuitterrain", "mirrorarenaterrain", "darkcrystalcavernterrain", "newworldterrain", "starlightarenaterrain"])) {
        move.boosts = {
          accuracy: -2
        };
      }
    },
base: {"boosts":{"accuracy":-1},"critRatio":1},
uncertain: false},
"focusblast": {onModifyMove(move) {
      if (this.field.isTerrain("ashenbeachterrain")) {
        move.accuracy = 90;
      }
    },
base: {"secondaries":[{"chance":10,"boosts":{"spd":-1}}],"critRatio":1},
uncertain: false},
"glitzyglow": {onModifyMove(move) {
      if (this.field.isTerrain("mirrorarenaterrain")) {
        move.self = {
          boosts: {
            evasion: 1
          },
          sideCondition: "lightscreen"
        };
      }
    },
base: {"self":{"sideCondition":"lightscreen"},"critRatio":1},
uncertain: false},
"grasspledge": {onBasePower(basePower, source, target) {
      if ((0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields")) return;
      if (this.field.terrainState.terrainChanges?.get("waterpledge") === 1 || this.field.terrainState.terrainChanges?.get("firepledge") === 1) {
        return this.chainModify([5325, 4096]);
      }
    },
base: {"critRatio":1},
uncertain: true},
"grasswhistle": {onModifyMove(move) {
      if (this.field.isTerrain("grassyterrain")) {
        move.accuracy = 80;
      }
      if (this.field.isTerrain("bewitchedwoodsterrain")) {
        move.accuracy = 85;
      }
    },
base: {"critRatio":1},
uncertain: false},
"grassyglide": {onModifyPriority(priority, source, target, move) {
      if (this.field.isAura("grassyterrain") || this.field.isTerrain("grassyterrain") && source.canBenefitFromTerrain()) {
        return priority + 1;
      }
    },
base: {"critRatio":1},
uncertain: false},
"growth": {onModifyMove(move, pokemon) {
      if (["sunnyday", "desolateland"].includes(pokemon.effectiveWeather()) || this.field.isTerrain(["grassyterrain", "forestterrain", "flowergarden1"]))
        move.boosts = {
          atk: 2,
          spa: 2
        };
    },
base: {"boosts":{"atk":1,"spa":1},"critRatio":1},
uncertain: false},
"gunkshot": {onModifyMove(move) {
      if (this.field.isTerrain("wastelandterrain")) {
        move.secondaries = [
          {
            chance: 7.5,
            status: "frz"
          },
          {
            chance: 7.5,
            status: "brn"
          },
          {
            chance: 7.5,
            status: "psn"
          },
          {
            chance: 7.5,
            status: "par"
          }
        ];
      }
    },
base: {"secondaries":[{"chance":30,"status":"psn"}],"critRatio":1},
uncertain: false},
"headsmash": {onModifyMove(move) {
      if (this.field.isTerrain("bewitchedwoodsterrain")) move.recoil = [1, 4];
    },
base: {"recoil":[1,2],"critRatio":1},
uncertain: false},
"healorder": {onModifyMove(move) {
      if (this.field.isTerrain("forestterrain")) {
        move.heal = [2, 3];
      }
    },
base: {"heal":[1,2],"critRatio":1},
uncertain: false},
"hex": {basePowerCallback(pokemon, target, move) {
      if (target.status || target.hasAbility("comatose") || this.field.isTerrain("infernaleclipseterrain") || pokemon.hasAbility("hauntingpresence") && ["taunt", "encore", "disable", "healblock"].some((id) => !!target.volatiles[id])) {
        this.debug("BP doubled from status condition");
        return move.basePower * 2;
      }
      return move.basePower;
    },
base: {"critRatio":1},
uncertain: false},
"hypnosis": {onModifyMove(move) {
      if (this.field.isTerrain("psychicterrain") || this.field.isTerrain("hauntedterrain")) {
        move.accuracy = 90;
      }
    },
base: {"critRatio":1},
uncertain: false},
"icywind": {onModifyMove(move, source, target) {
      if (target && this.field.isTerrain("coldeclipseterrain")) {
        move.accuracy = true;
      }
    },
base: {"secondaries":[{"chance":100,"boosts":{"spe":-1}}],"critRatio":1},
uncertain: false},
"infernalparade": {basePowerCallback(pokemon, target, move) {
      if ((0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields") && !target.status && !target.hasAbility("comatose") && !pokemon.hasAbility("sinisterblaze")) return move.basePower;
      if (target.status || target.hasAbility("comatose") || this.field.isTerrain("hauntedterrain") || pokemon.hasAbility("sinisterblaze")) return move.basePower * 2;
      return move.basePower;
    },
base: {"secondaries":[{"chance":30,"status":"brn"}],"critRatio":1},
uncertain: false},
"inferno": {onModifyMove(move) {
      if (this.field.isTerrain(["volcanicterrain"])) {
        move.accuracy = 100;
      }
    },
base: {"secondaries":[{"chance":100,"status":"brn"}],"critRatio":1},
uncertain: false},
"irondefense": {onModifyMove(move) {
      if (this.field.isTerrain("factoryterrain")) {
        move.boosts = {
          def: 3
        };
      }
    },
base: {"boosts":{"def":2},"critRatio":1},
uncertain: false},
"irontail": {onModifyMove(move) {
      if (this.field.isTerrain("electricterrain")) move.accuracy = true;
    },
onBasePower(basePower, source, target) {
      if ((0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields")) return;
      if (this.field.isTerrain("electricterrain")) return this.chainModify(1.5);
    },
base: {"secondaries":[{"chance":30,"boosts":{"def":-1}}],"critRatio":1},
uncertain: false},
"kinesis": {onModifyMove(move) {
      if (this.field.isTerrain("psychicterrain") || this.field.isTerrain("ashenbeachterrain")) {
        move.boosts = {
          accuracy: -2
        };
        move.selfBoost = {
          boosts: {
            spa: 2,
            atk: 2
          }
        };
      }
    },
base: {"boosts":{"accuracy":-1},"critRatio":1},
uncertain: false},
"lick": {onModifyMove(move) {
      if (this.field.isTerrain("hauntedterrain")) {
        move.secondaries = [];
        move.secondaries.push({
          chance: 100,
          status: "par"
        });
      }
    },
base: {"secondaries":[{"chance":30,"status":"par"}],"critRatio":1},
uncertain: false},
"lifedew": {onModifyMove(move) {
      if (this.field.isTerrain("corrosivemistterrain") || this.field.isTerrain("murkwatersurfaceterrain")) {
        move.secondary = {
          chance: 100,
          status: "psn"
        };
      }
      if (this.field.isTerrain(["watersurfaceterrain", "underwaterterrain", "midnightzoneterrain"])) {
        delete move.heal;
      }
      if (this.field.isTerrain("rainbowterrain") || this.field.isTerrain("holyterrain")) {
        move.heal = [1, 2];
      }
    },
base: {"heal":[1,4],"critRatio":1},
uncertain: false},
"lightthatburnsthesky": {onBasePower(basePower, source, target) {
      if ((0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields")) return;
      if (this.field.isTerrain("holyterrain") || this.field.isTerrain("starlightarenaterrain")) {
        return this.chainModify(1.3);
      }
    },
base: {"critRatio":1},
uncertain: false},
"magicpowder": {onModifyMove(move) {
      if (this.field.isTerrain("hauntedterrain") || this.field.isTerrain("bewitchedwoodsterrain")) {
        move.secondaries = [];
        move.secondaries.push({
          chance: 100,
          status: "slp"
        });
      }
    },
base: {"critRatio":1},
uncertain: false},
"meanlook": {onModifyMove(move) {
      if (this.field.isTerrain("hauntedterrain")) {
        move.target = "allAdjacentFoes";
      }
    },
base: {"critRatio":1},
uncertain: false},
"metalsound": {onModifyMove(move) {
      if (this.field.isTerrain("shortcircuitterrain") || this.field.isTerrain("factoryterrain")) {
        move.boosts = {
          spd: -3
        };
      }
    },
base: {"boosts":{"spd":-2},"critRatio":1},
uncertain: false},
"meteorbeam": {onModifyMove(move) {
      if (this.field.isTerrain("starlightarenaterrain")) {
        move.types = [move.type, "Dark"];
      }
    },
base: {"critRatio":1},
uncertain: false},
"mirrorshot": {onModifyMove(move) {
      if (this.field.isTerrain("mirrorarenaterrain")) {
        move.boosts = {
          accuracy: -1
        };
      }
    },
base: {"secondaries":[{"chance":30,"boosts":{"accuracy":-1}}],"critRatio":1},
uncertain: false},
"mistyexplosion": {onBasePower(basePower, source, target) {
      if ((0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields") && !this.field.isAura("mistyterrain")) return;
      if ((this.field.isTerrain(["mistyterrain", "corrosivemistterrain"]) || this.field.isAura("mistyterrain")) && source.canBenefitFromTerrain()) {
        this.debug("misty terrain boost");
        return this.chainModify(1.5);
      }
    },
base: {"critRatio":1},
uncertain: false},
"mountaingale": {onModifyMove(move) {
      if (this.field.isTerrain(["icyterrain", "mountainterrain", "snowymountainterrain"])) {
        move.accuracy = 100;
      }
    },
base: {"secondaries":[{"chance":30,"volatileStatus":"flinch"}],"critRatio":1},
uncertain: false},
"mudshot": {onModifyMove(move) {
      if (this.field.isTerrain("swampterrain")) {
        move.secondaries = [];
        move.secondaries = [{
          chance: 100,
          boosts: {
            spe: -2
          }
        }];
      }
    },
base: {"secondaries":[{"chance":100,"boosts":{"spe":-1}}],"critRatio":1},
uncertain: false},
"mysticalpower": {onModifyMove(move) {
      if (this.field.isTerrain("psychicterrain")) {
        move.secondaries = [];
        move.secondaries.push({
          chance: 100,
          boosts: {
            spa: 2
          }
        });
      }
    },
base: {"secondaries":[{"self":{"boosts":{"spa":1,"spd":1}}}],"critRatio":1},
uncertain: false},
"nastyplot": {onModifyMove(move) {
      if (this.field.isTerrain(["psychicterrain", "chessboardterrain", "infernaleclipseterrain"])) {
        move.boosts = {
          spa: 3
        };
      }
    },
base: {"boosts":{"spa":2},"critRatio":1},
uncertain: false},
"nightshade": {onModifyMove(move) {
      if (this.field.isTerrain("coldeclipseterrain")) {
        move.damage = 140;
      }
    },
base: {"critRatio":1},
uncertain: false},
"nobleroar": {onModifyMove(move) {
      if (this.field.isTerrain("fairytaleterrain") || this.field.isTerrain("dragonsdenterrain")) {
        move.boosts = {
          atk: -2,
          spa: -2
        };
      }
    },
base: {"boosts":{"atk":-1,"spa":-1},"critRatio":1},
uncertain: false},
"noretreat": {onModifyMove(move) {
      if (this.field.isTerrain("chessboardterrain")) {
        move.boosts = {
          atk: 2,
          def: -1,
          spe: 2,
          spd: -1,
          spa: 2
        };
      }
    },
base: {"boosts":{"atk":1,"def":1,"spa":1,"spd":1,"spe":1},"volatileStatus":"noretreat","critRatio":1},
uncertain: false},
"octazooka": {onModifyMove(move) {
      if (this.field.isTerrain("wastelandterrain")) {
        move.secondaries = [
          {
            chance: 10,
            status: "frz"
          },
          {
            chance: 10,
            status: "brn"
          },
          {
            chance: 10,
            status: "psn"
          },
          {
            chance: 10,
            status: "par"
          },
          {
            chance: 10,
            boosts: {
              accuracy: -1
            }
          }
        ];
      }
    },
base: {"secondaries":[{"chance":50,"boosts":{"accuracy":-1}}],"critRatio":1},
uncertain: false},
"paraboliccharge": {onModifyMove(move) {
      if (this.field.isTerrain("electricterrain")) {
        move.drain = [3, 4];
      }
    },
base: {"drain":[1,2],"critRatio":1},
uncertain: false},
"plasmafists": {onBasePower() {
      if (this.field.canSetTerrain("electricterrain"))
        return this.chainModify(1.3);
    },
base: {"critRatio":2},
uncertain: false},
"poisonpowder": {onModifyMove(move) {
      if (this.field.isTerrain("bewitchedwoodsterrain")) {
        move.accuracy = 85;
      }
    },
base: {"critRatio":1},
uncertain: false},
"powertrip": {basePowerCallback(pokemon, target, move) {
      if ((0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields")) return move.basePower + 20 * pokemon.positiveBoosts();
      let modifier = 1;
      if (this.field.isTerrain("coldeclipseterrain")) {
        modifier = 2;
      }
      const bp = move.basePower + 20 * modifier * pokemon.positiveBoosts();
      this.debug(`BP: ${bp}`);
      return bp;
    },
base: {"critRatio":1},
uncertain: false},
"psyblade": {onBasePower(basePower, source, target) {
      if ((0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields") && !this.field.isAura("electricterrain")) return;
      if (this.field.isTerrainOrAura("electricterrain")) {
        this.debug("psyblade electric terrain boost");
        return this.chainModify(1.5);
      }
    },
base: {"critRatio":1},
uncertain: false},
"psyshieldbash": {onModifyMove(move) {
      if (this.field.isTerrain("psychicterrain")) {
        move.secondaries = [];
        move.secondaries.push({
          chance: 100,
          boosts: {
            def: 1,
            spd: 1
          }
        });
      }
    },
base: {"secondaries":[{"chance":100,"self":{"boosts":{"def":1}}}],"critRatio":1},
uncertain: false},
"quiverdance": {onModifyMove(move) {
      if (this.field.isTerrain("bigtopterrain")) {
        move.boosts = {
          spa: 2,
          spd: 2,
          spe: 2
        };
      }
    },
base: {"boosts":{"spa":1,"spd":1,"spe":1},"critRatio":1},
uncertain: false},
"ragingfury": {onModifyMove(move) {
      if (this.field.isTerrain("volcanicterrain")) {
        move.selfBoost = {
          boosts: {
            atk: 1
          }
        };
      }
    },
base: {"self":{"volatileStatus":"lockedmove"},"secondaries":[{"chance":30,"status":"brn"}],"critRatio":1},
uncertain: false},
"risingvoltage": {basePowerCallback(source, target, move) {
      if ((0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields") && !this.field.isAura("electricterrain")) return move.basePower;
      if (this.field.isTerrainOrAura("electricterrain") && target.isGrounded()) {
        if (!source.isAlly(target)) this.hint(`${move.name}'s BP doubled on grounded target.`);
        return move.basePower * 2;
      }
      return move.basePower;
    },
base: {"critRatio":1},
uncertain: false},
"rockclimb": {onModifyMove(move) {
      if (this.field.isTerrain(["mountainterrain", "rockyterrain", "caveterrain", "desertterrain"])) {
        move.critRatio = (move.critRatio ?? 1) + 1;
      }
    },
base: {"secondaries":[{"chance":30,"volatileStatus":"confusion"}],"critRatio":1},
uncertain: false},
"rockpolish": {onModifyMove(move) {
      if (this.field.isTerrain("rockyterrain")) {
        move.boosts = {
          spe: 3
        };
      }
      if (this.field.isTerrain("crystalcavernterrain")) {
        move.boosts = {
          spe: 2,
          atk: 1,
          spa: 1
        };
      }
    },
base: {"boosts":{"spe":2},"critRatio":1},
uncertain: false},
"sandattack": {onModifyMove(move) {
      if (this.field.isTerrain("desertterrain") || this.field.isTerrain("ashenbeachterrain")) {
        move.boosts = { accuracy: -2 };
      }
    },
base: {"boosts":{"accuracy":-1},"critRatio":1},
uncertain: false},
"scaryface": {onModifyMove(move) {
      if (this.field.isTerrain("hauntedterrain")) {
        move.secondaries = [];
        move.secondaries.push({
          chance: 100,
          boosts: {
            spe: -4
          }
        });
      }
    },
base: {"boosts":{"spe":-2},"critRatio":1},
uncertain: false},
"secretpower": {onModifyMove(move, pokemon) {
      if (this.field.isTerrain("flowergarden5")) {
        Object.assign(move, this.dex.getActiveMove("petaldance"));
        move.target = "allAdjacentFoes";
        move.secondary = null;
        move.secondaries = null;
        return;
      }
      if (this.field.isTerrain("flowergarden1")) {
        Object.assign(move, this.dex.getActiveMove("sweetscent"));
        move.secondary = null;
        move.secondaries = null;
        return;
      }
      const currentTerrain = this.field.terrain;
      if (!currentTerrain || currentTerrain === "") return;
      if (currentTerrain === "icyterrain") {
        const iceShard = this.dex.moves.get("iceshard");
        move.name = iceShard.name;
        move.type = iceShard.type;
        move.basePower = iceShard.basePower;
        move.priority = iceShard.priority;
        move.accuracy = iceShard.accuracy;
      }
      move.secondaries = [];
      const terrainSecondaries = {
        ashenbeachterrain: [{ chance: 30, boosts: { accuracy: -1 } }],
        bewitchedwoodsterrain: [
          { chance: 10, status: "psn" },
          { chance: 10, status: "slp" },
          { chance: 10, status: "par" }
        ],
        bigtopterrain: [{ chance: 30, boosts: { spd: -1 } }],
        burningterrain: [{ chance: 30, status: "brn" }],
        caveterrain: [{ chance: 30, volatileStatus: "flinch" }],
        chessboardterrain: [{ chance: 30, boosts: { def: -1 } }],
        coldeclipseterrain: [{ chance: 30, status: "frz" }],
        rifteclipseterrain: [{ chance: 30, volatileStatus: "flinch" }],
        infernaleclipseterrain: [{ chance: 30, status: "brn" }],
        snowyterrain: [{ chance: 30, status: "frz" }],
        corrosivemistterrain: [{ chance: 30, status: "psn" }],
        corrosiveterrain: [{ chance: 30, status: "psn" }],
        crystalcavernterrain: [
          { chance: 7.5, volatileStatus: "confusion" },
          { chance: 7.5, status: "frz" },
          { chance: 7.5, status: "slp" },
          { chance: 7.5, status: "brn" }
        ],
        darkcrystalcavernterrain: [{ chance: 30, boosts: { accuracy: -1 } }],
        desertterrain: [{ chance: 30, boosts: { accuracy: -1 } }],
        dragonsdenterrain: [{ chance: 30, status: "brn" }],
        electricterrain: [{ chance: 30, status: "par" }],
        factoryterrain: [{ chance: 30, boosts: { atk: -1 } }],
        fairytaleterrain: [{ chance: 30, status: "slp" }],
        forestterrain: [{ chance: 30, status: "slp" }],
        glitchterrain: [{ chance: 30, boosts: { spe: -1 } }],
        grassyterrain: [{ chance: 30, status: "slp" }],
        hauntedterrain: [{ chance: 30, volatileStatus: "curse" }],
        holyterrain: [{ chance: 30, boosts: { spa: -1 } }],
        icyterrain: [{ chance: 30, status: "frz" }],
        inverseterrain: [{ chance: 30, volatileStatus: "confusion" }],
        mirrorarenaterrain: [{ chance: 30, boosts: { evasion: -1 } }],
        mistyterrain: [{ chance: 30, boosts: { spa: -1 } }],
        mountainterrain: [{ chance: 30, volatileStatus: "flinch" }],
        murkwatersurfaceterrain: [{ chance: 30, status: "psn" }],
        newworldterrain: [{
          chance: 30,
          boosts: { spa: -1, spe: -1, spd: -1, atk: -1, def: -1 }
        }],
        psychicterrain: [{ chance: 30, boosts: { spe: -1 } }],
        rainbowterrain: [
          { chance: 7.5, status: "par" },
          { chance: 7.5, status: "slp" },
          { chance: 7.5, status: "frz" },
          { chance: 7.5, status: "brn" }
        ],
        rockyterrain: [{ chance: 30, volatileStatus: "flinch" }],
        shortcircuitterrain: [{ chance: 30, status: "par" }],
        snowymountainterrain: [{ chance: 30, status: "frz" }],
        starlightarenaterrain: [{ chance: 30, boosts: { spd: -1 } }],
        superheatedterrain: [{ chance: 30, status: "brn" }],
        swampterrain: [{ chance: 30, boosts: { spe: -1 } }],
        underwaterterrain: [{ chance: 30, boosts: { atk: -1 } }],
        midnightzoneterrain: [{ chance: 30, boosts: { spa: -1 } }],
        volcanicterrain: [{ chance: 30, status: "brn" }],
        wastelandterrain: [
          { chance: 7.5, status: "brn" },
          { chance: 7.5, status: "par" },
          { chance: 7.5, status: "psn" },
          { chance: 7.5, status: "frz" }
        ],
        watersurfaceterrain: [{ chance: 30, boosts: { spe: -1 } }]
      };
      move.secondaries = terrainSecondaries[currentTerrain] || [];
    },
base: {"secondaries":[{"chance":30,"status":"par"}],"critRatio":1},
uncertain: false},
"shatteredpsyche": {onModifyMove(move) {
      if (this.field.isTerrain("psychicterrain")) {
        move.secondaries = [
          {
            chance: 100,
            volatileStatus: "confusion"
          }
        ];
      }
    },
base: {"critRatio":1},
uncertain: false},
"shiftgear": {onModifyMove(move) {
      if (this.field.isTerrain("factoryterrain")) {
        move.boosts = {
          spe: 2,
          atk: 2
        };
      }
    },
base: {"boosts":{"spe":2,"atk":1},"critRatio":1},
uncertain: false},
"shoreup": {onModifyType(move) {
      if (this.field.isTerrain("watersurfaceterrain")) {
        move.type = "Water";
      } else if (this.field.isTerrain("murkwatersurfaceterrain")) {
        move.type = "Water";
        move.types = ["Water", "Poison"];
      }
    },
base: {"critRatio":1},
uncertain: false},
"sing": {onModifyMove(move, source, target) {
      if (this.field.isTerrain("bigtopterrain")) {
        move.accuracy = 100;
      }
      if (source.name === "Typhlosion" && target?.name === "Gliscor") {
        move.volatileStatus = "tormented";
      }
    },
base: {"critRatio":1},
uncertain: false},
"sleeppowder": {onModifyMove(move) {
      if (this.field.isTerrain("bewitchedwoodsterrain")) {
        move.accuracy = 85;
      }
    },
base: {"critRatio":1},
uncertain: false},
"sludge": {onModifyMove(move) {
      if (this.field.isTerrain("wastelandterrain")) {
        move.secondaries = [
          {
            chance: 7.5,
            status: "frz"
          },
          {
            chance: 7.5,
            status: "brn"
          },
          {
            chance: 7.5,
            status: "psn"
          },
          {
            chance: 7.5,
            status: "par"
          }
        ];
      }
    },
base: {"secondaries":[{"chance":30,"status":"psn"}],"critRatio":1},
uncertain: false},
"sludgebomb": {onModifyMove(move) {
      if (this.field.isTerrain("wastelandterrain")) {
        move.secondaries = [
          {
            chance: 7.5,
            status: "frz"
          },
          {
            chance: 7.5,
            status: "brn"
          },
          {
            chance: 7.5,
            status: "psn"
          },
          {
            chance: 7.5,
            status: "par"
          }
        ];
      }
    },
base: {"secondaries":[{"chance":30,"status":"psn"}],"critRatio":1},
uncertain: false},
"sludgewave": {onModifyMove(move) {
      if (this.field.isTerrain("wastelandterrain")) {
        move.secondaries = [
          {
            chance: 2.5,
            status: "frz"
          },
          {
            chance: 2.5,
            status: "brn"
          },
          {
            chance: 2.5,
            status: "psn"
          },
          {
            chance: 2.5,
            status: "par"
          }
        ];
      }
    },
base: {"secondaries":[{"chance":10,"status":"psn"}],"critRatio":1},
uncertain: false},
"smokescreen": {onModifyMove(move) {
      if (this.field.isTerrain(["burningterrain", "corrosivemistterrain", "volcanicterrain"])) {
        move.boosts = {
          accuracy: -2
        };
      }
    },
base: {"boosts":{"accuracy":-1},"critRatio":1},
uncertain: false},
"snarl": {onModifyMove(move) {
      if (this.field.isWeather(["hail", "snow"]) || this.field.isTerrain("coldeclipseterrain")) {
        move.secondaries = [];
        move.secondaries.push({
          chance: 100,
          boosts: {
            spa: -2
          }
        });
      }
    },
base: {"secondaries":[{"chance":100,"boosts":{"spa":-1}}],"critRatio":1},
uncertain: false},
"snipeshot": {onModifyMove(move) {
      if (this.field.isTerrain("icyterrain")) {
        move.types = [move.type, "Ice"];
      }
    },
base: {"critRatio":2},
uncertain: false},
"solarbeam": {onModifyMove(move) {
      if (this.field.isTerrain("starlightarenaterrain")) {
        move.type = "Fairy";
      }
    },
base: {"critRatio":1},
uncertain: false},
"solarblade": {onModifyMove(move) {
      if (this.field.isTerrain("starlightarenaterrain")) {
        move.type = "Fairy";
      }
    },
base: {"critRatio":1},
uncertain: false},
"sonicboom": {onModifyMove(move) {
      if (this.field.isTerrain("rainbowterrain")) {
        move.damage = 140;
      }
    },
base: {"critRatio":1},
uncertain: false},
"splash": {onModifyMove(move) {
      if (this.field.isTerrain("watersurfaceterrain")) {
        move.secondaries = [];
        move.secondaries = [{
          chance: 100,
          boosts: {
            accuracy: -1
          }
        }];
      }
    },
base: {"critRatio":1},
uncertain: false},
"splinteredstormshards": {onBasePower() {
      if (this.field.canSetTerrain("rockyterrain"))
        return this.chainModify(1.3);
    },
base: {"critRatio":1},
uncertain: false},
"spotlight": {onModifyMove(move) {
      if (this.gameType === "freeforall") move.breaksProtect = true;
      if (this.field.isTerrain("bigtopterrain")) {
        move.boosts = {
          atk: 1,
          spa: 1
        };
        move.secondaries = [];
        move.secondaries.push({
          chance: 100,
          self: {
            boosts: {
              atk: 1,
              spa: 1
            }
          }
        });
      }
    },
base: {"volatileStatus":"spotlight","critRatio":1},
uncertain: false},
"springtidestorm": {onModifyMove(move) {
      if (this.field.isTerrain("mistyterrain")) {
        move.accuracy = true;
      }
    },
base: {"secondaries":[{"chance":30,"boosts":{"atk":-1}}],"critRatio":1},
uncertain: false},
"steelbeam": {onModifyMove(move) {
      if (this.field.isTerrain("shortcircuitterrain")) {
        move.selfdestruct = "always";
      }
    },
base: {"critRatio":1},
uncertain: false},
"stokedsparksurfer": {onBasePower() {
      if (this.field.canSetTerrain("electricterrain"))
        return this.chainModify(1.3);
    },
base: {"secondaries":[{"chance":100,"status":"par"}],"critRatio":1},
uncertain: false},
"strangesteam": {onModifyMove(move, source, target) {
      if (this.field.isTerrain("fairytaleterrain") || this.field.isTerrain("mistyterrain")) {
        move.secondaries = [];
        move.secondaries = [{
          chance: 100,
          volatileStatus: "confusion"
        }];
      }
    },
base: {"secondaries":[{"chance":20,"volatileStatus":"confusion"}],"critRatio":1},
uncertain: false},
"strength": {onModifyMove(move) {
      move.ignoreDefensive = true;
      move.infiltrates = true;
      if (this.field.isTerrain("ashenbeachterrain")) {
        move.types = ["Fighting", "Psychic"];
      }
    },
base: {"critRatio":1},
uncertain: false},
"strugglebug": {onModifyMove(move) {
      if (this.field.isTerrain("swampterrain")) {
        move.secondaries = [];
        move.secondaries = [{
          chance: 100,
          boosts: {
            spa: -2
          }
        }];
      }
    },
base: {"secondaries":[{"chance":100,"boosts":{"spa":-1}}],"critRatio":1},
uncertain: false},
"stunspore": {onModifyMove(move) {
      if (this.field.isTerrain("bewitchedwoodsterrain")) {
        move.accuracy = 85;
      }
    },
base: {"critRatio":1},
uncertain: false},
"sweetkiss": {onModifyMove(move) {
      if (this.field.isTerrain("mistyterrain")) {
        move.accuracy = 100;
      }
    },
base: {"volatileStatus":"confusion","critRatio":1},
uncertain: false},
"sweetscent": {onModifyMove(move) {
      if (this.field.isTerrain("flowergarden3")) {
        move.boosts = { def: -1, spd: -1, evasion: -1 };
        return;
      }
      if (this.field.isTerrain("mistyterrain")) {
        move.boosts = {
          evasion: -2,
          def: -1,
          spd: -1
        };
      }
    },
base: {"boosts":{"evasion":-2},"critRatio":1},
uncertain: false},
"swordsdance": {onModifyMove(move) {
      if (this.field.isTerrain("fairytaleterrain") || this.field.isTerrain("bigtopterrain")) {
        move.boosts = {
          atk: 3
        };
      }
    },
base: {"boosts":{"atk":2},"critRatio":1},
uncertain: false},
"tarshot": {onModifyMove(move) {
      if (this.field.isTerrain("murkwatersurfaceterrain")) {
        move.secondaries = [];
        move.secondaries = [{
          chance: 100,
          status: "psn",
          boosts: {
            spe: -1
          }
        }];
      }
      if (this.field.isTerrain("volcanicterrain")) {
        move.boosts = {
          spe: -2
        };
      }
    },
base: {"boosts":{"spe":-1},"volatileStatus":"tarshot","critRatio":1},
uncertain: false},
"tectonicrage": {onBasePower(basePower, source, target) {
      if ((0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields")) return;
      if (this.field.isTerrain("electricterrain")) {
        return this.chainModify(5325 / 4096);
      }
    },
base: {"critRatio":1},
uncertain: false},
"telekinesis": {onModifyMove(move) {
      if (this.field.isTerrain("psychicterrain")) {
        move.boosts = {
          accuracy: -2,
          spd: -2,
          def: -2
        };
      }
    },
base: {"volatileStatus":"telekinesis","critRatio":1},
uncertain: false},
"terrainpulse": {onModifyType(move, pokemon) {
      const aura = this.field.getAura();
      if (aura) {
        move.type = aura.mimicryType;
        return;
      }
      const terrainTypeMap = /* @__PURE__ */ new Map([
        ["ashenbeachterrain", "Ground"],
        ["bewitchedwoodsterrain", "Fairy"],
        ["bigtopterrain", "Fighting"],
        ["burningterrain", "Fire"],
        ["caveterrain", "Rock"],
        ["chessboardterrain", "Psychic"],
        ["coldeclipseterrain", "Ice"],
        ["rifteclipseterrain", "Dark"],
        ["infernaleclipseterrain", "Fire"],
        ["snowyterrain", "Ice"],
        ["corrosivemistterrain", "Poison"],
        ["corrosiveterrain", "Poison"],
        ["darkcrystalcavernterrain", "Dark"],
        ["desertterrain", "Ground"],
        ["dragonsdenterrain", "Dragon"],
        ["electricterrain", "Electric"],
        ["factoryterrain", "Steel"],
        ["fairytaleterrain", "Fairy"],
        ["flowergardenterrain", "Grass"],
        ["forestterrain", "Bug"],
        ["glitchterrain", "???"],
        ["grassyterrain", "Grass"],
        ["hauntedterrain", "Ghost"],
        ["holyterrain", "Normal"],
        ["icyterrain", "Ice"],
        ["inverseterrain", "Normal"],
        ["mirrorarenaterrain", "Ice"],
        ["mistyterrain", "Fairy"],
        ["mountainterrain", "Rock"],
        ["murkwatersurfaceterrain", "Poison"],
        ["newworldterrain", "Random"],
        ["psychicterrain", "Psychic"],
        ["rainbowterrain", "Dragon"],
        ["rockyterrain", "Rock"],
        ["shortcircuitterrain", "Electric"],
        ["snowymountainterrain", "Ice"],
        ["starlightarenaterrain", "Dark"],
        ["superheatedterrain", "Fire"],
        ["swampterrain", "Water"],
        ["underwaterterrain", "Water"],
        ["volcanicterrain", "Fire"],
        ["wastelandterrain", "Poison"],
        ["watersurfaceterrain", "Water"]
      ]);
      let newType;
      if (this.field.isTerrain("crystalcavernterrain")) {
        const counter = ["Fire", "Water", "Grass", "Psychic"];
        newType = counter[this.CrystalCavernCounter];
      } else {
        newType = terrainTypeMap.get(this.field.getTerrain().id);
      }
      if (newType === "Random") {
        newType = this.sample(["Water", "Fire", "Grass", "Steel", "Ground", "Rock", "Bug", "Ice", "Ghost", "Fairy", "Dark", "Electric", "Normal", "Fighting", "Flying", "Psychic", "Dragon", "Poison"]);
      }
      move.type = newType !== void 0 ? newType : "Normal";
    },
onBasePower(basePower, source, target) {
      if ((0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields")) return;
      if (!this.field.getAura() && this.field.isTerrain(["electricterrain", "grassyterrain", "mistyterrain", "psychicterrain", "rainbowterrain"])) return this.chainModify(2);
    },
base: {"critRatio":1},
uncertain: true},
"thunder": {onModifyMove(move, pokemon, target) {
      switch (target?.effectiveWeather()) {
        case "raindance":
        case "primordialsea":
          move.accuracy = true;
          break;
        case "sunnyday":
        case "desolateland":
          move.accuracy = 50;
          break;
      }
      if (this.field.isTerrain("mountainterrain") || this.field.isTerrain("snowymountainterrain")) move.accuracy = true;
      if (typeof move.accuracy === "number" && move.accuracy < 70 && (0, import_adaptive_cycle.adaptiveEnvironment)(pokemon, "weather")) move.accuracy = 70;
    },
base: {"secondaries":[{"chance":30,"status":"par"}],"critRatio":1},
uncertain: false},
"toxic": {onModifyMove(move) {
      if (this.field.isTerrain("corrosivemistterrain"))
        move.accuracy = 100;
    },
base: {"critRatio":1},
uncertain: false},
"tripleaxel": {onModifyMove(move) {
      if (this.field.isTerrain("bigtopterrain")) {
        move.accuracy = 100;
      }
    },
base: {"critRatio":1},
uncertain: false},
"venoshock": {onBasePower(basePower, pokemon, target) {
      if ((0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields") && !["psn", "tox"].includes(target.status)) return;
      if (target.status === "psn" || target.status === "tox" || this.field.isTerrain(["corrosivemistterrain", "corrosiveterrain", "murkwatersurfaceterrain", "wastelandterrain"])) {
        return this.chainModify(2);
      }
    },
base: {"critRatio":1},
uncertain: false},
"victorydance": {onModifyMove(move) {
      if (this.field.isTerrain("bigtopterrain")) {
        move.boosts = {
          atk: 2,
          def: 2,
          spe: 2
        };
      }
    },
base: {"boosts":{"atk":1,"def":1,"spe":1},"critRatio":1},
uncertain: false},
"volttackle": {onModifyMove(move) {
      if (this.field.isTerrain("electricterrain")) delete move.recoil;
    },
onBasePower(basePower, source, target) {
      if ((0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields")) return;
      if (this.field.isTerrain("electricterrain")) return this.chainModify(1.5);
    },
base: {"recoil":[33,100],"secondaries":[{"chance":10,"status":"par"}],"critRatio":1},
uncertain: false},
"waterpledge": {onBasePower(basePower, source, target) {
      if ((0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields")) return;
      if (this.field.terrainState.terrainChanges?.get("grasspledge") === 1 || this.field.terrainState.terrainChanges?.get("firepledge") === 1) {
        return this.chainModify([5325, 4096]);
      }
    },
base: {"critRatio":1},
uncertain: true},
"wavecrash": {onModifyMove(move) {
      if (this.field.isTerrain("watersurfaceterrain") || this.field.isTerrain("underwaterterrain")) {
        move.recoil = [25, 100];
      }
    },
base: {"recoil":[33,100],"critRatio":1},
uncertain: false},
"weatherball": {onModifyMove(move, pokemon) {
      switch (pokemon.effectiveWeather()) {
        case "sunnyday":
        case "desolateland":
          move.basePower *= 2;
          break;
        case "raindance":
        case "primordialsea":
          move.basePower *= 2;
          break;
        case "sandstorm":
          move.basePower *= 2;
          break;
        case "hail":
        case "snowscape":
          move.basePower *= 2;
          break;
        case "deltastream":
          move.basePower *= 2;
          break;
        default:
          if (this.field.isTerrain("rainbowterrain")) {
            move.basePower *= 2;
            break;
          }
      }
      this.debug(`BP: ${move.basePower}`);
    },
base: {"critRatio":1},
uncertain: false},
"whirlpool": {onModifyMove(move) {
      if (this.field.isTerrain("watersurfaceterrain") || this.field.isTerrain("underwaterterrain")) {
        move.secondaries = [];
        move.secondaries?.push({
          chance: 100,
          volatileStatus: "confusion"
        });
      }
    },
base: {"volatileStatus":"partiallytrapped","critRatio":1},
uncertain: false},
"wildboltstorm": {onModifyMove(move, pokemon, target) {
      if (target && (["raindance", "primordialsea"].includes(target.effectiveWeather()) || this.field.isTerrain(["electricterrain", "snowymountainterrain", "mountainterrain"]))) {
        move.accuracy = true;
      }
    },
base: {"secondaries":[{"chance":20,"status":"par"}],"critRatio":1},
uncertain: false},
"wildcharge": {onModifyMove(move) {
      if (this.field.isTerrain("electricterrain")) {
        move.recoil = void 0;
      }
    },
base: {"recoil":[1,4],"critRatio":1},
uncertain: false},
"willowisp": {onModifyMove(move, source, target) {
      if (source.hasType("Ghost")) {
        move.accuracy = true;
        return;
      }
      if (this.field.isTerrain(["burningterrain", "volcanicterrain"])) {
        move.accuracy = 100;
      }
      if (this.field.isTerrain("hauntedterrain")) {
        move.accuracy = 90;
      }
      if (target && source.hasType("Fire")) {
        move.accuracy = 100;
      }
    },
base: {"critRatio":1},
uncertain: false},
"steelystrike": {onBasePower(basePower, source, target) {
      if ((0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields")) return;
      if (this.field.isTerrain("fairytaleterrain")) {
        this.add("-message", "The blade cuts true!");
        return this.chainModify(1.5);
      }
    },
base: {"critRatio":1},
uncertain: false},
"stabbyswarm": {onModifyMove() {
      if (this.field.isTerrain("forestterrain")) this.add("-message", "They're coming out of the woodwork!");
    },
onBasePower(basePower, source, target) {
      if ((0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields")) return;
      if (this.field.isTerrain("forestterrain")) return this.chainModify(1.5);
    },
base: {"volatileStatus":"partiallytrapped","critRatio":1},
uncertain: false},
"aquabatics": {onModifyMove(move) {
    if (this.field.isTerrain("bigtopterrain")) move.boosts = { spa: 2, spe: 2 };
  },
base: {"boosts":{"spa":1,"spe":1},"critRatio":1},
uncertain: false},
"superumdmove": {onModifyMove(move) { move.category = this.sample(['Physical', 'Special']); },
base: {"critRatio":1},
uncertain: true},
"kaboom": {onModifyMove(move) { move.secondary = {chance: 100, self: {boosts: {[move.category === 'Physical' ? 'atk' : 'spa']: 1}}}; move.secondaries = [move.secondary]; if (this.field.isTerrainOrAura('electricterrain')) delete move.recoil; },
base: {"recoil":[1,4],"secondaries":[{"chance":100,"self":{"boosts":{"spa":1}}}],"critRatio":1},
uncertain: false},
"cactibash": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
onBasePower(bp, source, target) {
      if (this.field.isTerrain("desertterrain")) return this.chainModify((0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5));
    },
base: {"critRatio":1},
uncertain: false},
"corrosivestrike": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
onBasePower(bp, source, target) {
      if (this.field.isTerrain("corrosiveterrain")) return this.chainModify((0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5));
    },
base: {"volatileStatus":"corrosivestrike","critRatio":1},
uncertain: false},
"toxicvial": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
base: {"boosts":{"atk":-1,"spa":-1},"critRatio":1},
uncertain: false},
"flutterscales": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
onBasePower(bp, source, target) {
      if (this.field.isTerrainOrAura("rainbowterrain")) return this.chainModify((0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5));
    },
base: {"critRatio":1},
uncertain: false},
"spiritmend": {function(move, source, target) {
    const result = spiritModify.call(this, move, source, target);
    if (this.field.isTerrain("hauntedterrain")) move.heal = [66, 100];
    return result;
  },
base: {"heal":[1,2],"critRatio":1},
uncertain: false},
"chistrike": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
onBasePower(bp, source, target) {
    if (this.field.isTerrain("ashenbeachterrain")) return this.chainModify((0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3));
  },
base: {"critRatio":1},
uncertain: false},
"gunkrock": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
onBasePower(bp, source, target) {
    if (this.field.isTerrain("wastelandterrain")) return this.chainModify((0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5));
  },
base: {"secondaries":[{"chance":30}],"critRatio":1},
uncertain: false},
"frozenrefractals": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
base: {"critRatio":1},
uncertain: false},
"nomoswish": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
base: {"boosts":{"def":1,"spd":1},"critRatio":1},
uncertain: false},
"queensgambit": {onModifyMove(move, source) { if (this.field.isTerrain('chessboardterrain') && source.Role === 'Queen') move.willCrit = true; },
base: {"self":{"boosts":{"def":-1,"spd":-1}},"critRatio":1},
uncertain: false},
"darkclasp": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
onBasePower(bp, source, target) {
    if (this.field.isTerrain("darkcrystalcavernterrain")) return this.chainModify((0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.5));
  },
base: {"critRatio":1},
uncertain: false},
"beatdown": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
base: {"critRatio":1},
uncertain: false},
"infernalrage": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
base: {"critRatio":1},
uncertain: false},
"m3g4qu4k3": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
onBasePower(basePower, source, target) {
      if (this.field.isTerrain("glitchterrain")) return this.chainModify((0, import_adaptive_cycle.adaptiveFieldMultiplier)(this, source, target, 1.3));
    },
base: {"critRatio":1},
uncertain: false},
"winddance": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
base: {"critRatio":1},
uncertain: false},
"timeblade": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
base: {"critRatio":1},
uncertain: false},
"crestcleave": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
base: {"drain":[1,3],"critRatio":1},
uncertain: false},
"sirensveil": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
base: {"boosts":{"def":1,"spd":1},"volatileStatus":"sirensveil","critRatio":1},
uncertain: false},
"sirenswrath": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
base: {"critRatio":1},
uncertain: false},
"rocknroll": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
base: {"boosts":{"def":-1},"critRatio":1},
uncertain: false},
"dragonrend": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
base: {"critRatio":1},
uncertain: false},
"airstreamassault": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
base: {"critRatio":1},
uncertain: false},
"wisteriamaelstrom": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
base: {"critRatio":1},
uncertain: false},
"deiludicium": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
base: {"critRatio":1},
uncertain: false},
"nostraswish": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
base: {"critRatio":1},
uncertain: false},
"swarmsnare": {function(active, source, target) {
      const result = modify?.call(this, active, source, target);
      const move = active;
      const field = this.field.terrain, aura = this.field.auraField;
      const full = yangField(id, field);
      move.yang = { field, aura, startingHP: source.hp, stage: this.field.flowerGardenStage(), full, eligible: full || (YangBonusAuras[id] || []).includes(aura), seen: /* @__PURE__ */ new Set(), hits: /* @__PURE__ */ new Map(), once: false, messages: /* @__PURE__ */ new Set() };
      if (!move.yang.eligible) return result;
      switch (id) {
        case "kaboom":
          delete move.recoil;
          break;
        case "chistrike":
          move.ignoreNegativeOffensive = true;
          break;
        case "gunkrock":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.secondaries = move.secondaries?.map((s) => ({ ...s, chance: 40 }));
          if (move.secondary) move.secondary = { ...move.secondary, chance: 40 };
          break;
        case "queensgambit":
          move.self = { boosts: move.category === "Physical" ? { def: -1 } : { spd: -1 } };
          break;
        case "crestcleave":
          move.drain = [1, 2];
          break;
        case "rocknroll":
          move.boosts = { def: -2 };
          break;
        case "dragonrend":
          move.ignoreScreens = true;
          break;
        case "infernalrage":
          move.yangSecondaryTargets = /* @__PURE__ */ new Set();
          move.yangPreserveField = full;
          move.secondaries = [...move.secondaries || [], { chance: 30, onHit(target2, source2, effect) {
            const attack = effect;
            if (target2.isAlly(source2) || (target2.getMoveHitData(effect).damage || 0) <= 0 || attack.yang?.seen.has(target2)) return;
            attack.yang?.seen.add(target2);
            if (target2.trySetStatus("brn", source2, effect)) message(this, attack, "Charlotte\u2019s inferno left a searing brand!");
          } }];
          break;
      }
      return result;
    },
base: {"critRatio":1},
uncertain: false},
"vorpalblade": {onModifyMove(move, source) {
      const probe = this.dex.getActiveMove("secretpower");
      this.dex.moves.get("secretpower").onModifyMove?.call(this, probe, source, source);
      move.secondaries = probe.secondaries ? this.dex.deepClone(probe.secondaries) : null;
      if (this.field.isTerrain("glitchterrain")) {
        Object.assign(move, { name: "Unown Buster" });
        move.basePower = 175;
        move.type = "???";
        move.fullDamageSpread = true;
      }
    },
base: {"secondaries":[{"chance":30,"status":"par"}],"critRatio":1},
uncertain: false},
"royalcollision": {onModifyMove(move) {
      if (this.field.isTerrain("watersurfaceterrain") || this.field.isTerrain("underwaterterrain")) {
        move.recoil = [25, 100];
      }
    },
base: {"recoil":[1,10],"critRatio":1},
uncertain: false}};
const BattleAuraRules = {"riftaura":{"id":"riftaura","name":"Rift Aura","turns":5,"mimicryType":"Dark","secretPowerMove":"astonish","naturePowerMove":"darkpulse","damageMultipliers":{},"secondaryTypeAdditions":{},"typeMultipliers":{"Dark":1.3,"Ghost":1.2,"Fairy":0.75},"typeCondition":"none","moveMessages":{},"typeMessage":"The Rift Aura altered the attack's power!","endMessage":"The Rift Aura faded.","statusBuffs":[],"statusNerfs":[]},"ashenaura":{"id":"ashenaura","name":"Ashen Aura","turns":5,"mimicryType":"Fire","secretPowerMove":"incinerate","naturePowerMove":"infernalparade","damageMultipliers":{"darkpulse":1.5,"snarl":1.5,"nightdaze":1.5,"nightslash":1.5,"lashout":1.5,"fierywrath":1.5,"bitterblade":1.5,"infernalparade":1.5},"secondaryTypeAdditions":{},"typeMultipliers":{"Fire":1.3},"typeCondition":"none","moveMessages":{},"typeMessage":"The Ashen Aura strengthened the attack!","endMessage":"The Ashen Aura faded.","statusBuffs":[],"statusNerfs":[]},"frozenaura":{"id":"frozenaura","name":"Frozen Aura","turns":5,"mimicryType":"Ice","secretPowerMove":"bodyslam","naturePowerMove":"icebeam","damageMultipliers":{"icebeam":1.2,"blizzard":1.2,"frostbreath":1.2,"aurorabeam":1.2,"darkpulse":1.5,"snarl":1.5,"nightdaze":1.5,"nightslash":1.5,"lashout":1.5,"stompingtantrum":1.5,"ragingfury":1.5,"thrash":1.5,"outrage":1.5,"rage":1.5,"freezingglare":1.5,"fierywrath":1.5,"roaroftime":1.5,"bitterblade":1.5,"bittermalice":1.5,"chillingwater":2},"secondaryTypeAdditions":{},"typeMultipliers":{"Ice":1.3},"typeCondition":"none","moveMessages":{},"typeMessage":"The Frozen Aura strengthened the attack!","endMessage":"The Frozen Aura faded.","statusBuffs":[],"statusNerfs":[]},"electricterrain":{"id":"electricterrain","name":"Electric Aura","turns":5,"mimicryType":"Electric","secretPowerMove":"shockwave","naturePowerMove":"thunderbolt","damageMultipliers":{"explosion":1.5,"selfdestruct":1.5,"hurricane":1.5,"surf":1.5,"smackdown":1.5,"muddywater":1.5,"thousandarrows":1.5,"wildboltstorm":1.5,"magnetbomb":2},"secondaryTypeAdditions":{"explosion":"Electric","selfdestruct":"Electric","hurricane":"Electric","surf":"Electric","smackdown":"Electric","muddywater":"Electric","thousandarrows":"Electric"},"typeMultipliers":{"Electric":1.3},"typeCondition":"electric","moveMessages":{"explosion":"The explosion became hyper-charged!","selfdestruct":"The explosion became hyper-charged!","hurricane":"The attack became hyper-charged!","surf":"The attack became hyper-charged!","smackdown":"The attack became hyper-charged!","muddywater":"The attack became hyper-charged!","thousandarrows":"The attack became hyper-charged!","wildboltstorm":"The attack became hyper-charged!","magnetbomb":"The attack powered up!"},"typeMessage":"The Electric Aura strengthened the attack!","endMessage":"The electricity disappeared from the battlefield.","statusBuffs":["magnetrise","risingvoltage","psyblade"],"statusNerfs":[]},"grassyterrain":{"id":"grassyterrain","name":"Grassy Aura","turns":5,"mimicryType":"Grass","secretPowerMove":"seedbomb","naturePowerMove":"energyball","damageMultipliers":{"fairywind":1.5,"silverwind":1.5,"ominouswind":1.5,"icywind":1.5,"razorwind":1.5,"gust":1.5,"twister":1.5},"secondaryTypeAdditions":{},"typeMultipliers":{"Grass":1.3},"typeCondition":"grounded","moveMessages":{"fairywind":"The wind picked up strength from the Aura!","silverwind":"The wind picked up strength from the Aura!","ominouswind":"The wind picked up strength from the Aura!","icywind":"The wind picked up strength from the Aura!","razorwind":"The wind picked up strength from the Aura!","gust":"The wind picked up strength from the Aura!","twister":"The wind picked up strength from the Aura!"},"typeMessage":"The Grassy Aura strengthened the attack!","endMessage":"The grass disappeared from the battlefield.","statusBuffs":["grassyglide"],"statusNerfs":[]},"mistyterrain":{"id":"mistyterrain","name":"Misty Aura","turns":5,"mimicryType":"Fairy","secretPowerMove":"mistball","naturePowerMove":"mistball","damageMultipliers":{"mysticalfire":1.5,"magicalleaf":1.5,"doomdesire":1.5,"icywind":1.5,"mistball":1.5,"aurasphere":1.5,"steameruption":1.5,"silverwind":1.5,"moongeistbeam":1.5,"smog":1.5,"clearsmog":1.5,"strangesteam":1.5,"springtidestorm":1.5,"hydrosteam":1.5},"secondaryTypeAdditions":{},"typeMultipliers":{"Fairy":1.3},"typeCondition":"none","moveMessages":{"mysticalfire":"The mist's energy strengthened the attack!","magicalleaf":"The mist's energy strengthened the attack!","doomdesire":"The mist's energy strengthened the attack!","icywind":"The mist's energy strengthened the attack!","mistball":"The mist's energy strengthened the attack!","aurasphere":"The mist's energy strengthened the attack!","steameruption":"The mist's energy strengthened the attack!","silverwind":"The mist's energy strengthened the attack!","moongeistbeam":"The mist's energy strengthened the attack!","smog":"The mist's energy strengthened the attack!","clearsmog":"The mist's energy strengthened the attack!","strangesteam":"The mist's energy strengthened the attack!","springtidestorm":"The mist's energy strengthened the attack!","hydrosteam":"The mist's energy strengthened the attack!"},"typeMessage":"The Misty Aura strengthened the attack!","endMessage":"The mist disappeared from the battlefield.","statusBuffs":["mistyexplosion"],"statusNerfs":[]},"rainbowterrain":{"id":"rainbowterrain","name":"Rainbow Aura","turns":5,"mimicryType":"Dragon","secretPowerMove":"aurorabeam","naturePowerMove":"aurorabeam","damageMultipliers":{"silverwind":1.5,"mysticalfire":1.5,"dragonpulse":1.5,"triattack":1.5,"sacredfire":1.5,"firepledge":1.5,"waterpledge":1.5,"grasspledge":1.5,"aurorabeam":1.5,"mirrorbeam":1.5,"judgment":1.5,"deiludicium":1.5,"relicsong":1.5,"hiddenpower":1.5,"secretpower":1.5,"weatherball":1.5,"mistball":1.5,"heartstamp":1.5,"moonblast":1.5,"zenheadbutt":1.5,"sparklingaria":1.5,"fleurcannon":1.5,"prismaticlaser":1.5,"twinkletackle":1.5,"oceanicoperetta":1.5,"solarbeam":1.5,"solarblade":1.5,"dazzlinggleam":1.5,"luminacrash":1.5},"secondaryTypeAdditions":{},"typeMultipliers":{"Normal":1.3},"typeCondition":"special","moveMessages":{"silverwind":"The attack was rainbow-charged!","mysticalfire":"The attack was rainbow-charged!","dragonpulse":"The attack was rainbow-charged!","triattack":"The attack was rainbow-charged!","sacredfire":"The attack was rainbow-charged!","firepledge":"The attack was rainbow-charged!","waterpledge":"The attack was rainbow-charged!","grasspledge":"The attack was rainbow-charged!","aurorabeam":"The attack was rainbow-charged!","mirrorbeam":"The attack was rainbow-charged!","judgment":"The attack was rainbow-charged!","deiludicium":"The attack was rainbow-charged!","relicsong":"The attack was rainbow-charged!","hiddenpower":"The attack was rainbow-charged!","secretpower":"The attack was rainbow-charged!","weatherball":"The attack was rainbow-charged!","mistball":"The attack was rainbow-charged!","heartstamp":"The attack was rainbow-charged!","moonblast":"The attack was rainbow-charged!","zenheadbutt":"The attack was rainbow-charged!","sparklingaria":"The attack was rainbow-charged!","fleurcannon":"The attack was rainbow-charged!","prismaticlaser":"The attack was rainbow-charged!","twinkletackle":"The attack was rainbow-charged!","oceanicoperetta":"The attack was rainbow-charged!","solarbeam":"The attack was rainbow-charged!","solarblade":"The attack was rainbow-charged!","dazzlinggleam":"The attack was rainbow-charged!","luminacrash":"The attack was rainbow-charged!"},"typeMessage":"The rainbow energized the attack!","endMessage":"The rainbow disappeared.","statusBuffs":[],"statusNerfs":[]},"psychicterrain":{"id":"psychicterrain","name":"Psychic Aura","turns":5,"mimicryType":"Psychic","secretPowerMove":"psychic","naturePowerMove":"psychic","damageMultipliers":{"secretpower":1.5,"hiddenpower":1.5,"hex":1.5,"magicalleaf":1.5,"mysticalfire":1.5,"moonblast":1.5,"aurasphere":1.5,"focusblast":1.5,"mindblown":1.5},"secondaryTypeAdditions":{},"typeMultipliers":{"Psychic":1.3},"typeCondition":"psychic","moveMessages":{"secretpower":"The psychic energy strengthened the attack!","hiddenpower":"The psychic energy strengthened the attack!","hex":"The psychic energy strengthened the attack!","magicalleaf":"The psychic energy strengthened the attack!","mysticalfire":"The psychic energy strengthened the attack!","moonblast":"The psychic energy strengthened the attack!","aurasphere":"The psychic energy strengthened the attack!","focusblast":"The psychic energy strengthened the attack!","mindblown":"The psychic energy strengthened the attack!"},"typeMessage":"The Psychic Aura strengthened the attack!","endMessage":"The psychic energy disappeared from the battlefield.","statusBuffs":["expandingforce"],"statusNerfs":[]},"hauntedaura":{"turns":5,"damageMultipliers":{},"secondaryTypeAdditions":{},"typeCondition":"none","moveMessages":{},"statusBuffs":[],"statusNerfs":[],"id":"hauntedaura","name":"Haunted Aura","mimicryType":"Ghost","secretPowerMove":"astonish","naturePowerMove":"shadowball","typeMultipliers":{"Ghost":1.2},"typeMessage":"Wandering spirits empowered the attack!","endMessage":"The wandering spirits departed."},"bewitchedaura":{"turns":5,"damageMultipliers":{},"secondaryTypeAdditions":{},"typeCondition":"none","moveMessages":{},"statusBuffs":[],"statusNerfs":[],"id":"bewitchedaura","name":"Bewitched Aura","mimicryType":"Fairy","secretPowerMove":"confusion","naturePowerMove":"psychic","typeMultipliers":{"Psychic":1.2,"Fairy":1.2},"typeMessage":"The strange hush empowered the attack!","endMessage":"The bewitching hush faded."}};
const BattleAuraMethods = {baseAuraTypeBoost(move, source, target) {
    if ((0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields")) return 1;
    const type = move.type;
    if (type === "Ice" && ["icyterrain", "snowymountainterrain", "snowyterrain"].includes(this.terrain)) return 1.5;
    if (type === "Ice" && this.terrain === "coldeclipseterrain") return 1.2;
    if (type === "Fire" && ["burningterrain", "volcanicterrain", "infernaleclipseterrain"].includes(this.terrain)) return 1.5;
    if (type === "Dark" && ["coldeclipseterrain", "rifteclipseterrain", "infernaleclipseterrain"].includes(this.terrain)) return 1.5;
    if (type === "Ghost" && this.terrain === "rifteclipseterrain") return 1.2;
    if (type === "Ghost" && this.terrain === "hauntedterrain") return 1.5;
    if (type === "Dark" && this.terrain === "bewitchedwoodsterrain") return 1.3;
    if (move.id === "deiludicium" && this.isTerrain("rainbowterrain") && type === "Normal" && move.category === "Special") return 1.5;
    if (this.terrain === "bewitchedwoodsterrain" && ["Fairy", "Grass"].includes(type)) return 1.5;
    if (this.terrain === "glitchterrain" && type === "Psychic") return 1.2;
    if (this.terrain === "factoryterrain" && type === "Electric") return 1.2;
    if (this.terrain === "fairytaleterrain" && type === "Fairy") return 1.5;
    if (this.terrain === "forestterrain" && type === "Grass") return 1.5;
    if (this.terrain === "swampterrain" && type === "Grass") return 1.3;
    if (this.terrain === "holyterrain") {
      if (["Fairy", "Normal"].includes(type) && move.category === "Special") return 1.5;
      if (type === "Psychic") return 1.2;
    }
    if (this.terrain === "starlightarenaterrain" && !this.weather) {
      if (type === "Psychic" || type === "Dark") return 1.5;
      if (type === "Fairy") return 1.3;
    }
    if (type === "Electric" && target.isGrounded()) {
      if (this.terrain === "watersurfaceterrain") return 1.5;
      if (this.terrain === "murkwatersurfaceterrain") return 5325 / 4096;
    }
    return 1;
  },
auraPowerMultiplier(source, target, move) {
    if (this.isAura("hauntedaura") || this.isAura("bewitchedaura")) {
      const haunted = this.isAura("hauntedaura");
      if (this.isTerrain(haunted ? "hauntedterrain" : "bewitchedwoodsterrain")) return 1;
      if ((move.types || [move.type]).some((type) => (haunted ? ["Ghost"] : ["Psychic", "Fairy"]).includes(type))) {
        this.battle.add("-message", this.getAura().typeMessage);
        return 1.2;
      }
      return 1;
    }
    const aura = this.getAura();
    if (!aura || move.category === "Status") return 1;
    let multiplier = aura.damageMultipliers[move.id] || 1;
    if (move.id === "deiludicium" && this.isAura("rainbowterrain") && this.isTerrain("rainbowterrain")) multiplier = 1;
    if (this.isAura("frozenaura") && !(0, import_adaptive_cycle.adaptiveEnvironment)(target, "fields")) {
      let shared = 1;
      if (["icyterrain", "snowymountainterrain", "coldeclipseterrain"].includes(this.terrain) && move.id === "bittermalice") shared = 1.5;
      if (["icyterrain", "snowyterrain"].includes(this.terrain) && move.id === "chillingwater") shared = 2;
      if (this.terrain === "coldeclipseterrain") {
        if (["fierywrath", "freezingglare", "lashout", "outrage", "ragingfury", "rage", "roaroftime", "stompingtantrum", "thrash", "bittermalice"].includes(move.id)) shared = 1.5;
      }
      if (shared > 1) multiplier = Math.max(shared, multiplier) / shared;
    }
    if (multiplier !== 1) this.battle.add("-message", aura.moveMessages[move.id] || aura.typeMessage);
    const types = move.types || [move.type];
    const grounded = source.canBenefitFromTerrain() && !source.isSemiInvulnerable();
    const typeAllowed = aura.typeCondition === "none" || (aura.typeCondition === "special" ? move.category === "Special" : grounded);
    if (!typeAllowed || this.auraField === "electricterrain" && this.terrain === "shortcircuitterrain") return multiplier;
    for (const [type, boost] of Object.entries(aura.typeMultipliers)) {
      if (!types.includes(type)) continue;
      if (this.isAura("riftaura") && type === "Fairy") {
        const basePenalty = (0, import_adaptive_cycle.adaptiveEnvironment)(source, "fields") ? 1 : this.terrain === "rifteclipseterrain" ? 0.5 : this.terrain === "infernaleclipseterrain" && move.id !== "spiritbreak" ? 0.5 : 1;
        multiplier *= Math.min(basePenalty, boost) / basePenalty;
        this.battle.add("-message", aura.typeMessage);
        continue;
      }
      let baseBoost = move.type === type ? this.baseAuraTypeBoost(move, source, target) : 1;
      if (this.isAura("ashenaura") && type === "Fire") baseBoost = this.baseAuraTypeBoost({ ...move, type: "Fire" }, source, target);
      if (this.isAura("frozenaura") && this.terrain === "coldeclipseterrain" && type === "Ice") {
        baseBoost = this.baseAuraTypeBoost({ ...move, type: "Ice" }, source, target);
      }
      if (this.isAura("riftaura") && ["coldeclipseterrain", "rifteclipseterrain", "infernaleclipseterrain"].includes(this.terrain)) {
        baseBoost = this.baseAuraTypeBoost({ ...move, type }, source, target);
      }
      const overlapFloor = this.isAura("riftaura") ? 1 : 1.5;
      multiplier *= baseBoost > 1 && boost > 1 ? Math.max(overlapFloor, baseBoost, boost) / baseBoost : boost;
      this.battle.add("-message", aura.typeMessage);
    }
    return multiplier;
  }};
const BattleAuraHooks = {onModifyMove(move) {
      const aura = this.field.getAura();
      if (!aura) return;
      const addedType = aura.secondaryTypeAdditions[move.id];
      if (addedType) {
        const types = move.types || [move.type];
        move.types = types.includes(addedType) ? types : [...types, addedType];
      }
    },
onBasePower(basePower, source, target, move) {
      let multiplier = this.field.auraPowerMultiplier(source, target, move);
      if (move.id === "terrainpulse") multiplier *= 2;
      return this.chainModify(multiplier);
    }};
if (typeof window !== 'undefined') Object.assign(window, {BattleAuraRules, BattleAuraMethods, BattleAuraHooks});
if (typeof window !== 'undefined') (window as any).BattleFieldMoveRules = BattleFieldMoveRules;
if (typeof window !== 'undefined') (window as any).BattleFieldRules = BattleFieldRules;
if (typeof require === 'function') (global as any).BattleFieldRules = BattleFieldRules;
const BattleNaturePowerMoves = {"":"triattack","flowergarden1":"growth","flowergarden2":"triattack","flowergarden3":"triattack","flowergarden4":"triattack","flowergarden5":"petalblizzard","ashenbeachterrain":"meditate","bewitchedwoodsterrain":"alluringvoice","bigtopterrain":"acrobatics","burningterrain":"flamethrower","caveterrain":"rocktomb","chessboardterrain":"ancientpower","coldeclipseterrain":"icebeam","rifteclipseterrain":"darkpulse","infernaleclipseterrain":"infernalparade","corrosivemistterrain":"venoshock","corrosiveterrain":"acid","crystalcavernterrain":"powergem","darkcrystalcavernterrain":"darkpulse","desertterrain":"sandtomb","dragonsdenterrain":"dragonpulse","factoryterrain":"geargrind","fairytaleterrain":"secretsword","forestterrain":"woodhammer","glitchterrain":"metronome","hauntedterrain":"phantomforce","holyterrain":"judgment","icyterrain":"icebeam","inverseterrain":"trickroom","mirrorarenaterrain":"mirrorshot","mountainterrain":"rockslide","murkwatersurfaceterrain":"sludgewave","newworldterrain":"spacialrend","rainbowterrain":"aurorabeam","rockyterrain":"rocksmash","shortcircuitterrain":"discharge","snowymountainterrain":"avalanche","snowyterrain":"powdersnow","starlightarenaterrain":"moonblast","superheatedterrain":"heatwave","swampterrain":"muddywater","midnightzoneterrain":"anchorshot","underwaterterrain":"waterpulse","volcanicterrain":"flamethrower","wastelandterrain":"gunkshot","watersurfaceterrain":"whirlpool","electricterrain":"thunderbolt","grassyterrain":"energyball","mistyterrain":"mistball","psychicterrain":"psychic"};
if (typeof window !== 'undefined') (window as any).BattleNaturePowerMoves = BattleNaturePowerMoves;
